export default {
  "express": [
    {
      "id": 1,
      "address": "yunda",
      "value": "韵达快递"
    },
    {
      "id": 2,
      "address": "youzhengguonei",
      "value": "邮政快递包裹"
    },
    {
      "id": 3,
      "address": "shunfeng",
      "value": "顺丰速运"
    },
    {
      "id": 4,
      "address": "zhongtong",
      "value": "中通快递"
    },
    {
      "id": 5,
      "address": "shentong",
      "value": "申通快递"
    },
    {
      "id": 6,
      "address": "huitongkuaidi",
      "value": "百世快递"
    },
    {
      "id": 7,
      "address": "yuantong",
      "value": "圆通速递"
    },
    {
      "id": 8,
      "address": "jd",
      "value": "京东物流"
    },
    {
      "id": 9,
      "address": "tiantian",
      "value": "天天快递"
    },
    {
      "id": 10,
      "address": "ems",
      "value": "EMS"
    },
    {
      "id": 11,
      "address": "debangwuliu",
      "value": "德邦"
    },
    {
      "id": 12,
      "address": "dhl",
      "value": "DHL-中国件"
    },
    {
      "id": 13,
      "address": "debangkuaidi",
      "value": "德邦快递"
    },
    {
      "id": 14,
      "address": "youshuwuliu",
      "value": "优速快递"
    },
    {
      "id": 15,
      "address": "auexpress",
      "value": "澳邮中国快运"
    },
    {
      "id": 16,
      "address": "zhaijisong",
      "value": "宅急送"
    },
    {
      "id": 17,
      "address": "fedex",
      "value": "FedEx-国际件"
    },
    {
      "id": 18,
      "address": "japanposten",
      "value": "日本（Japan Post）"
    },
    {
      "id": 19,
      "address": "pjbest",
      "value": "品骏快递"
    },
    {
      "id": 20,
      "address": "baishiwuliu",
      "value": "百世快运"
    },
    {
      "id": 21,
      "address": "auspost",
      "value": "澳大利亚(Australia Post)"
    },
    {
      "id": 22,
      "address": "ndwl",
      "value": "南方传媒物流"
    },
    {
      "id": 23,
      "address": "yundakuaiyun",
      "value": "韵达快运"
    },
    {
      "id": 24,
      "address": "danniao",
      "value": "丹鸟"
    },
    {
      "id": 25,
      "address": "tnt",
      "value": "TNT"
    },
    {
      "id": 26,
      "address": "suer",
      "value": "速尔快递"
    },
    {
      "id": 27,
      "address": "ewe",
      "value": "EWE全球快递"
    },
    {
      "id": 28,
      "address": "fedexus",
      "value": "FedEx-美国件"
    },
    {
      "id": 29,
      "address": "usps",
      "value": "USPS"
    },
    {
      "id": 30,
      "address": "suning",
      "value": "苏宁物流"
    },
    {
      "id": 31,
      "address": "disifang",
      "value": "递四方"
    },
    {
      "id": 32,
      "address": "jiajiwuliu",
      "value": "佳吉快运"
    },
    {
      "id": 33,
      "address": "yimidida",
      "value": "壹米滴答"
    },
    {
      "id": 34,
      "address": "annengwuliu",
      "value": "安能快运"
    },
    {
      "id": 35,
      "address": "zhimakaimen",
      "value": "芝麻开门"
    },
    {
      "id": 36,
      "address": "flyway",
      "value": "程光快递"
    },
    {
      "id": 37,
      "address": "wherexpess",
      "value": "威盛快递"
    },
    {
      "id": 38,
      "address": "jinguangsudikuaijian",
      "value": "京广速递"
    },
    {
      "id": 39,
      "address": "youzhengbk",
      "value": "邮政标准快递"
    },
    {
      "id": 40,
      "address": "upsen",
      "value": "UPS-全球件"
    },
    {
      "id": 41,
      "address": "aramex",
      "value": "Aramex"
    },
    {
      "id": 42,
      "address": "emsguoji",
      "value": "EMS-国际件"
    },
    {
      "id": 43,
      "address": "zhongtongkuaiyun",
      "value": "中通快运"
    },
    {
      "id": 44,
      "address": "kuayue",
      "value": "跨越速运"
    },
    {
      "id": 45,
      "address": "zlxdjwl",
      "value": "中粮鲜到家物流"
    },
    {
      "id": 46,
      "address": "rrs",
      "value": "日日顺物流"
    },
    {
      "id": 47,
      "address": "ups",
      "value": "UPS"
    },
    {
      "id": 48,
      "address": "tiandihuayu",
      "value": "天地华宇"
    },
    {
      "id": 49,
      "address": "longbanwuliu",
      "value": "龙邦速递"
    },
    {
      "id": 50,
      "address": "jiayunmeiwuliu",
      "value": "加运美"
    },
    {
      "id": 51,
      "address": "tntuk",
      "value": "TNT UK"
    },
    {
      "id": 52,
      "address": "youzhengguoji",
      "value": "国际包裹"
    },
    {
      "id": 53,
      "address": "jiuyescm",
      "value": "九曳供应链"
    },
    {
      "id": 54,
      "address": "yuxinwuliu",
      "value": "宇鑫物流"
    },
    {
      "id": 55,
      "address": "ocs",
      "value": "OCS"
    },
    {
      "id": 56,
      "address": "lianhaowuliu",
      "value": "联昊通"
    },
    {
      "id": 57,
      "address": "dhlen",
      "value": "DHL-全球件"
    },
    {
      "id": 58,
      "address": "qexpress",
      "value": "易达通快递"
    },
    {
      "id": 59,
      "address": "yuantongkuaiyun",
      "value": "圆通快运"
    },
    {
      "id": 60,
      "address": "wanxiangwuliu",
      "value": "万象物流"
    },
    {
      "id": 61,
      "address": "citylink",
      "value": "City-Link"
    },
    {
      "id": 62,
      "address": "ytchengnuoda",
      "value": "承诺达"
    },
    {
      "id": 63,
      "address": "zhuanyunsifang",
      "value": "转运四方"
    },
    {
      "id": 64,
      "address": "quanfengkuaidi",
      "value": "全峰快递"
    },
    {
      "id": 65,
      "address": "yuntrack",
      "value": "YUN TRACK"
    },
    {
      "id": 66,
      "address": "subida",
      "value": "速必达"
    },
    {
      "id": 67,
      "address": "ubonex",
      "value": "优邦速运"
    },
    {
      "id": 68,
      "address": "weitepai",
      "value": "微特派"
    },
    {
      "id": 69,
      "address": "zhongsukuaidi",
      "value": "中速快递"
    },
    {
      "id": 70,
      "address": "canpost",
      "value": "加拿大(Canada Post)"
    },
    {
      "id": 71,
      "address": "farlogistis",
      "value": "泛远国际物流"
    },
    {
      "id": 72,
      "address": "annto",
      "value": "安得物流"
    },
    {
      "id": 73,
      "address": "xdexpress",
      "value": "迅达速递"
    },
    {
      "id": 74,
      "address": "lianbangkuaidi",
      "value": "联邦快递"
    },
    {
      "id": 75,
      "address": "zhaijibian",
      "value": "宅急便"
    },
    {
      "id": 76,
      "address": "shpost",
      "value": "同城快寄"
    },
    {
      "id": 77,
      "address": "meiquick",
      "value": "美快国际物流"
    },
    {
      "id": 78,
      "address": "guotongkuaidi",
      "value": "国通快递"
    },
    {
      "id": 79,
      "address": "emsbg",
      "value": "EMS包裹"
    },
    {
      "id": 80,
      "address": "ftd",
      "value": "富腾达国际货运"
    },
    {
      "id": 81,
      "address": "quanyikuaidi",
      "value": "全一快递"
    },
    {
      "id": 82,
      "address": "coe",
      "value": "COE"
    },
    {
      "id": 83,
      "address": "superb",
      "value": "Superb Grace"
    },
    {
      "id": 84,
      "address": "arkexpress",
      "value": "方舟速递"
    },
    {
      "id": 85,
      "address": "ausexpress",
      "value": "澳世速递"
    },
    {
      "id": 86,
      "address": "astexpress",
      "value": "安世通快递"
    },
    {
      "id": 87,
      "address": "xinfengwuliu",
      "value": "信丰物流"
    },
    {
      "id": 88,
      "address": "gslhkd",
      "value": "联合快递"
    },
    {
      "id": 89,
      "address": "lntjs",
      "value": "特急送"
    },
    {
      "id": 90,
      "address": "exfresh",
      "value": "安鲜达"
    },
    {
      "id": 91,
      "address": "sxexpress",
      "value": "三象速递"
    },
    {
      "id": 92,
      "address": "hengluwuliu",
      "value": "恒路物流"
    },
    {
      "id": 93,
      "address": "yangbaoguo",
      "value": "洋包裹"
    },
    {
      "id": 94,
      "address": "bpost",
      "value": "比利时（Bpost）"
    },
    {
      "id": 95,
      "address": "banma",
      "value": "斑马物流"
    },
    {
      "id": 96,
      "address": "wjkwl",
      "value": "万家康物流"
    },
    {
      "id": 97,
      "address": "nsf",
      "value": "新顺丰（NSF）"
    },
    {
      "id": 98,
      "address": "zhongtiewuliu",
      "value": "中铁物流"
    },
    {
      "id": 99,
      "address": "shd56",
      "value": "商海德物流"
    },
    {
      "id": 100,
      "address": "dpduk",
      "value": "DPD UK"
    },
    {
      "id": 101,
      "address": "hkpost",
      "value": "中国香港(HongKong Post)"
    },
    {
      "id": 102,
      "address": "huangmajia",
      "value": "黄马甲"
    },
    {
      "id": 103,
      "address": "dhlde",
      "value": "DHL-德国件（DHL Deutschland）"
    },
    {
      "id": 104,
      "address": "valueway",
      "value": "美通"
    },
    {
      "id": 105,
      "address": "yuntongkuaidi",
      "value": "运通中港"
    },
    {
      "id": 106,
      "address": "gdkd",
      "value": "港快速递"
    },
    {
      "id": 107,
      "address": "xlobo",
      "value": "Xlobo贝海国际"
    },
    {
      "id": 108,
      "address": "ueq",
      "value": "UEQ快递"
    },
    {
      "id": 109,
      "address": "polarexpress",
      "value": "极地快递"
    },
    {
      "id": 110,
      "address": "epanex",
      "value": "泛捷国际速递"
    },
    {
      "id": 111,
      "address": "dsukuaidi",
      "value": "D速快递"
    },
    {
      "id": 112,
      "address": "euasia",
      "value": "欧亚专线"
    },
    {
      "id": 113,
      "address": "chukou1",
      "value": "出口易"
    },
    {
      "id": 114,
      "address": "unitedex",
      "value": "联合速运"
    },
    {
      "id": 115,
      "address": "ontrac",
      "value": "OnTrac"
    },
    {
      "id": 116,
      "address": "postnl",
      "value": "荷兰邮政(PostNL international registered mail)"
    },
    {
      "id": 117,
      "address": "huanqiu",
      "value": "环球速运"
    },
    {
      "id": 118,
      "address": "zhongtongguoji",
      "value": "中通国际"
    },
    {
      "id": 119,
      "address": "tmwexpress",
      "value": "明达国际速递"
    },
    {
      "id": 120,
      "address": "postdanmarken",
      "value": "丹麦(Post Denmark)"
    },
    {
      "id": 121,
      "address": "ecmscn",
      "value": "易客满"
    },
    {
      "id": 122,
      "address": "emsinten",
      "value": "EMS-国际件-英文"
    },
    {
      "id": 123,
      "address": "shenghuiwuliu",
      "value": "盛辉物流"
    },
    {
      "id": 124,
      "address": "fedexcn",
      "value": "Fedex-国际件-中文"
    },
    {
      "id": 125,
      "address": "tnten",
      "value": "TNT-全球件"
    },
    {
      "id": 126,
      "address": "zhonghuan",
      "value": "中环快递"
    },
    {
      "id": 127,
      "address": "esinotrans",
      "value": "中外运"
    },
    {
      "id": 128,
      "address": "sdto",
      "value": "速达通"
    },
    {
      "id": 129,
      "address": "yousutongda",
      "value": "优速通达"
    },
    {
      "id": 130,
      "address": "royalmail",
      "value": "英国小包（Royal Mail）"
    },
    {
      "id": 131,
      "address": "dpex",
      "value": "DPEX"
    },
    {
      "id": 132,
      "address": "bsht",
      "value": "百事亨通"
    },
    {
      "id": 133,
      "address": "jingshun",
      "value": "景顺物流"
    },
    {
      "id": 134,
      "address": "bulgarian",
      "value": "保加利亚（Bulgarian Posts）"
    },
    {
      "id": 135,
      "address": "pochta",
      "value": "俄罗斯邮政(Russian Post)"
    },
    {
      "id": 136,
      "address": "dpd",
      "value": "DPD"
    },
    {
      "id": 137,
      "address": "emsen",
      "value": "EMS-英文"
    },
    {
      "id": 138,
      "address": "yafengsudi",
      "value": "亚风速递"
    },
    {
      "id": 139,
      "address": "changjiang",
      "value": "长江国际速递"
    },
    {
      "id": 140,
      "address": "gxwl",
      "value": "光线速递"
    },
    {
      "id": 141,
      "address": "chnexp",
      "value": "中翼国际物流"
    },
    {
      "id": 142,
      "address": "aotsd",
      "value": "澳天速运"
    },
    {
      "id": 143,
      "address": "meixi",
      "value": "美西快递"
    },
    {
      "id": 144,
      "address": "rlgaus",
      "value": "澳洲飞跃物流"
    },
    {
      "id": 145,
      "address": "zhongyouwuliu",
      "value": "中邮物流"
    },
    {
      "id": 146,
      "address": "chengguangkuaidi",
      "value": "程光快递"
    },
    {
      "id": 147,
      "address": "rufengda",
      "value": "如风达"
    },
    {
      "id": 148,
      "address": "chinaicip",
      "value": "卓志速运"
    },
    {
      "id": 149,
      "address": "sxjdfreight",
      "value": "顺心捷达"
    },
    {
      "id": 150,
      "address": "ztky",
      "value": "中铁快运"
    },
    {
      "id": 151,
      "address": "idamalu",
      "value": "大马鹿"
    },
    {
      "id": 152,
      "address": "cnpex",
      "value": "CNPEX中邮快递"
    },
    {
      "id": 153,
      "address": "parcelforce",
      "value": "英国大包、EMS（Parcel Force）"
    },
    {
      "id": 154,
      "address": "bazirim",
      "value": "皮牙子快递"
    },
    {
      "id": 155,
      "address": "swisspostcn",
      "value": "瑞士邮政"
    },
    {
      "id": 156,
      "address": "uluckex",
      "value": "优联吉运"
    },
    {
      "id": 157,
      "address": "anxl",
      "value": "安迅物流"
    },
    {
      "id": 158,
      "address": "zhongchuan",
      "value": "众川国际"
    },
    {
      "id": 159,
      "address": "xinbangwuliu",
      "value": "新邦物流"
    },
    {
      "id": 160,
      "address": "sunjex",
      "value": "新杰物流"
    },
    {
      "id": 161,
      "address": "dpexen",
      "value": "Toll"
    },
    {
      "id": 162,
      "address": "aae",
      "value": "AAE-中国件"
    },
    {
      "id": 163,
      "address": "ucs",
      "value": "合众速递(UCS）"
    },
    {
      "id": 164,
      "address": "decnlh",
      "value": "德中快递"
    },
    {
      "id": 165,
      "address": "xunsuexpress",
      "value": "迅速快递"
    },
    {
      "id": 166,
      "address": "meiguokuaidi",
      "value": "美国快递"
    },
    {
      "id": 167,
      "address": "crazyexpress",
      "value": "疯狂快递"
    },
    {
      "id": 168,
      "address": "zyzoom",
      "value": "增速跨境"
    },
    {
      "id": 169,
      "address": "kerrytj",
      "value": "嘉里大荣物流"
    },
    {
      "id": 170,
      "address": "datianwuliu",
      "value": "大田物流"
    },
    {
      "id": 171,
      "address": "ane66",
      "value": "安能快递"
    },
    {
      "id": 172,
      "address": "singpost",
      "value": "新加坡小包(Singapore Post)"
    },
    {
      "id": 173,
      "address": "wowvip",
      "value": "沃埃家"
    },
    {
      "id": 174,
      "address": "japanpost",
      "value": "日本郵便"
    },
    {
      "id": 175,
      "address": "sxhongmajia",
      "value": "红马甲物流"
    },
    {
      "id": 176,
      "address": "lbex",
      "value": "龙邦物流"
    },
    {
      "id": 177,
      "address": "hd",
      "value": "宏递快运"
    },
    {
      "id": 178,
      "address": "kingfreight",
      "value": "货运皇"
    },
    {
      "id": 179,
      "address": "koreapost",
      "value": "韩国（Korea Post）"
    },
    {
      "id": 180,
      "address": "transrush",
      "value": "TransRush"
    },
    {
      "id": 181,
      "address": "zhongtongphone",
      "value": "中通（带电话）"
    },
    {
      "id": 182,
      "address": "koreapostcn",
      "value": "韩国邮政"
    },
    {
      "id": 183,
      "address": "hrex",
      "value": "锦程快递"
    },
    {
      "id": 184,
      "address": "synship",
      "value": "SYNSHIP快递"
    },
    {
      "id": 185,
      "address": "edtexpress",
      "value": "e直运"
    },
    {
      "id": 186,
      "address": "jialidatong",
      "value": "嘉里大通"
    },
    {
      "id": 187,
      "address": "yuananda",
      "value": "源安达"
    },
    {
      "id": 188,
      "address": "saiaodimmb",
      "value": "赛澳递for买卖宝"
    },
    {
      "id": 189,
      "address": "sendtochina",
      "value": "速递中国"
    },
    {
      "id": 190,
      "address": "postnlcn",
      "value": "荷兰邮政-中文(PostNL international registered mail)"
    },
    {
      "id": 191,
      "address": "hermes",
      "value": "Hermes"
    },
    {
      "id": 192,
      "address": "kuaijiesudi",
      "value": "快捷速递"
    },
    {
      "id": 193,
      "address": "yingchao",
      "value": "英超物流"
    },
    {
      "id": 194,
      "address": "deutschepost",
      "value": "德国(Deutsche Post)"
    },
    {
      "id": 195,
      "address": "swisspost",
      "value": "瑞士(Swiss Post)"
    },
    {
      "id": 196,
      "address": "westwing",
      "value": "西翼物流"
    },
    {
      "id": 197,
      "address": "baishiyp",
      "value": "百世云配"
    },
    {
      "id": 198,
      "address": "stoexpress",
      "value": "美国申通"
    },
    {
      "id": 199,
      "address": "abcglobal",
      "value": "全球快运"
    },
    {
      "id": 200,
      "address": "pcaexpress",
      "value": "PCA Express"
    },
    {
      "id": 201,
      "address": "tmg",
      "value": "株式会社T.M.G"
    },
    {
      "id": 202,
      "address": "bdatong",
      "value": "八达通"
    },
    {
      "id": 203,
      "address": "jieanda",
      "value": "捷安达"
    },
    {
      "id": 204,
      "address": "sagawa",
      "value": "佐川急便"
    },
    {
      "id": 205,
      "address": "trakpak",
      "value": "TRAKPAK"
    },
    {
      "id": 206,
      "address": "csuivi",
      "value": "法国(La Poste)"
    },
    {
      "id": 207,
      "address": "beebird",
      "value": "锋鸟物流"
    },
    {
      "id": 208,
      "address": "jiayiwuliu",
      "value": "佳怡物流"
    },
    {
      "id": 209,
      "address": "pingandatengfei",
      "value": "平安达腾飞"
    },
    {
      "id": 210,
      "address": "fastway",
      "value": "Fastway Ireland"
    },
    {
      "id": 211,
      "address": "suteng",
      "value": "广东速腾物流"
    },
    {
      "id": 212,
      "address": "bpostinter",
      "value": "比利时国际(Bpost international)"
    },
    {
      "id": 213,
      "address": "shipgce",
      "value": "飞洋快递"
    },
    {
      "id": 214,
      "address": "tntau",
      "value": "TNT Australia"
    },
    {
      "id": 215,
      "address": "fastgo",
      "value": "速派快递(FastGo)"
    },
    {
      "id": 216,
      "address": "shengfengwuliu",
      "value": "盛丰物流"
    },
    {
      "id": 217,
      "address": "tstexp",
      "value": "TST速运通"
    },
    {
      "id": 218,
      "address": "sutongwuliu",
      "value": "速通物流"
    },
    {
      "id": 219,
      "address": "zteexpress",
      "value": "ZTE中兴物流"
    },
    {
      "id": 220,
      "address": "guexp",
      "value": "全联速运"
    },
    {
      "id": 221,
      "address": "lineone",
      "value": "一号线"
    },
    {
      "id": 222,
      "address": "hyytes",
      "value": "恒宇运通"
    },
    {
      "id": 223,
      "address": "shangcheng",
      "value": "尚橙物流"
    },
    {
      "id": 224,
      "address": "nebuex",
      "value": "星云速递"
    },
    {
      "id": 225,
      "address": "signedexpress",
      "value": "签收快递"
    },
    {
      "id": 226,
      "address": "newsway",
      "value": "家家通快递"
    },
    {
      "id": 227,
      "address": "yuanchengwuliu",
      "value": "远成物流"
    },
    {
      "id": 228,
      "address": "auod",
      "value": "澳德物流"
    },
    {
      "id": 229,
      "address": "littlebearbear",
      "value": "小熊物流"
    },
    {
      "id": 230,
      "address": "emswuliu",
      "value": "EMS物流"
    },
    {
      "id": 231,
      "address": "lantiankuaidi",
      "value": "蓝天快递"
    },
    {
      "id": 232,
      "address": "newzealand",
      "value": "新西兰（New Zealand Post）"
    },
    {
      "id": 233,
      "address": "ganzhongnengda",
      "value": "能达速递"
    },
    {
      "id": 234,
      "address": "nederlandpost",
      "value": "荷兰速递(Nederland Post)"
    },
    {
      "id": 235,
      "address": "colissimo",
      "value": "法国小包（colissimo）"
    },
    {
      "id": 236,
      "address": "yundaexus",
      "value": "美国云达"
    },
    {
      "id": 237,
      "address": "stoe56",
      "value": "申通快运"
    },
    {
      "id": 238,
      "address": "cces",
      "value": "CCES/国通快递"
    },
    {
      "id": 239,
      "address": "qinyuan",
      "value": "秦远物流"
    },
    {
      "id": 240,
      "address": "europe8",
      "value": "败欧洲"
    },
    {
      "id": 241,
      "address": "jym56",
      "value": "加运美速递"
    },
    {
      "id": 242,
      "address": "koalaexp",
      "value": "考拉速递"
    },
    {
      "id": 243,
      "address": "italiane",
      "value": "意大利(Poste Italiane)"
    },
    {
      "id": 244,
      "address": "royalmailcn",
      "value": "英国邮政小包"
    },
    {
      "id": 245,
      "address": "blueskyexpress",
      "value": "蓝天快递"
    },
    {
      "id": 246,
      "address": "youyou",
      "value": "优优速递"
    },
    {
      "id": 247,
      "address": "adapost",
      "value": "安达速递"
    },
    {
      "id": 248,
      "address": "yidatong",
      "value": "易达通"
    },
    {
      "id": 249,
      "address": "cccc58",
      "value": "中集冷云"
    },
    {
      "id": 250,
      "address": "dhlbenelux",
      "value": "DHL Benelux"
    },
    {
      "id": 251,
      "address": "jiujiuwl",
      "value": "久久物流"
    },
    {
      "id": 252,
      "address": "heimao56",
      "value": "黑猫速运"
    },
    {
      "id": 253,
      "address": "ycgky",
      "value": "远成快运"
    },
    {
      "id": 254,
      "address": "haihongwangsong",
      "value": "海红网送"
    },
    {
      "id": 255,
      "address": "fanyukuaidi",
      "value": "凡宇快递"
    },
    {
      "id": 256,
      "address": "correosdees",
      "value": "西班牙(Correos de Espa?a)"
    },
    {
      "id": 257,
      "address": "jinan",
      "value": "金岸物流"
    },
    {
      "id": 258,
      "address": "rhtexpress",
      "value": "睿和泰速运"
    },
    {
      "id": 259,
      "address": "bqcwl",
      "value": "百千诚物流"
    },
    {
      "id": 260,
      "address": "shunfengen",
      "value": "顺丰-美国件"
    },
    {
      "id": 261,
      "address": "wlwex",
      "value": "星空国际"
    },
    {
      "id": 262,
      "address": "efs",
      "value": "EFS Post（平安快递）"
    },
    {
      "id": 263,
      "address": "lijisong",
      "value": "成都立即送"
    },
    {
      "id": 264,
      "address": "doortodoor",
      "value": "CJ物流"
    },
    {
      "id": 265,
      "address": "la911",
      "value": "鼎润物流"
    },
    {
      "id": 266,
      "address": "uhi",
      "value": "优海国际速递"
    },
    {
      "id": 267,
      "address": "ruidianyouzheng",
      "value": "瑞典（Sweden Post）"
    },
    {
      "id": 268,
      "address": "baitengwuliu",
      "value": "百腾物流"
    },
    {
      "id": 269,
      "address": "httx56",
      "value": "汇通天下物流"
    },
    {
      "id": 270,
      "address": "postserv",
      "value": "台湾（中华邮政）"
    },
    {
      "id": 271,
      "address": "taijin",
      "value": "泰进物流"
    },
    {
      "id": 272,
      "address": "anxindakuaixi",
      "value": "安信达"
    },
    {
      "id": 273,
      "address": "guangdongyouzhengwuliu",
      "value": "广东邮政"
    },
    {
      "id": 274,
      "address": "jxfex",
      "value": "集先锋快递"
    },
    {
      "id": 275,
      "address": "minghangkuaidi",
      "value": "民航快递"
    },
    {
      "id": 276,
      "address": "eiffel",
      "value": "艾菲尔国际速递"
    },
    {
      "id": 277,
      "address": "bosind",
      "value": "堡昕德速递"
    },
    {
      "id": 278,
      "address": "luben",
      "value": "陆本速递 LUBEN EXPRESS"
    },
    {
      "id": 279,
      "address": "onehcang",
      "value": "一号仓"
    },
    {
      "id": 280,
      "address": "aus",
      "value": "澳世速递"
    },
    {
      "id": 281,
      "address": "hnht56",
      "value": "鸿泰物流"
    },
    {
      "id": 282,
      "address": "homecourier",
      "value": "如家国际快递"
    },
    {
      "id": 283,
      "address": "baifudongfang",
      "value": "百福东方"
    },
    {
      "id": 284,
      "address": "macao",
      "value": "中国澳门(Macau Post)"
    },
    {
      "id": 285,
      "address": "freakyquick",
      "value": "FQ狂派速递"
    },
    {
      "id": 286,
      "address": "dongjun",
      "value": "成都东骏物流"
    },
    {
      "id": 287,
      "address": "guoeryue",
      "value": "天天快物流"
    },
    {
      "id": 288,
      "address": "newgistics",
      "value": "Newgistics"
    },
    {
      "id": 289,
      "address": "szyouzheng",
      "value": "深圳邮政"
    },
    {
      "id": 290,
      "address": "wanjiawuliu",
      "value": "万家物流"
    },
    {
      "id": 291,
      "address": "wuliuky",
      "value": "五六快运"
    },
    {
      "id": 292,
      "address": "hangrui",
      "value": "上海航瑞货运"
    },
    {
      "id": 293,
      "address": "qichen",
      "value": "启辰国际速递"
    },
    {
      "id": 294,
      "address": "tykd",
      "value": "天翼快递"
    },
    {
      "id": 295,
      "address": "tywl99",
      "value": "天翼物流"
    },
    {
      "id": 296,
      "address": "ukrpostcn",
      "value": "乌克兰邮政包裹"
    },
    {
      "id": 297,
      "address": "boyol",
      "value": "贝业物流"
    },
    {
      "id": 298,
      "address": "yiouzhou",
      "value": "易欧洲国际物流"
    },
    {
      "id": 299,
      "address": "jietekuaidi",
      "value": "捷特快递"
    },
    {
      "id": 300,
      "address": "nanjingshengbang",
      "value": "晟邦物流"
    },
    {
      "id": 301,
      "address": "oneexpress",
      "value": "一速递"
    },
    {
      "id": 302,
      "address": "shunfenghk",
      "value": "顺丰-繁体"
    },
    {
      "id": 303,
      "address": "iparcel",
      "value": "UPS i-parcel"
    },
    {
      "id": 304,
      "address": "a2u",
      "value": "A2U速递"
    },
    {
      "id": 305,
      "address": "uszcn",
      "value": "转运中国"
    },
    {
      "id": 306,
      "address": "kjde",
      "value": "跨境直邮通"
    },
    {
      "id": 307,
      "address": "maxeedexpress",
      "value": "澳洲迈速快递"
    },
    {
      "id": 308,
      "address": "zhongjiwuliu",
      "value": "中技物流"
    },
    {
      "id": 309,
      "address": "szuem",
      "value": "联运通物流"
    },
    {
      "id": 310,
      "address": "asendiausa",
      "value": "Asendia USA"
    },
    {
      "id": 311,
      "address": "cnausu",
      "value": "中澳速递"
    },
    {
      "id": 312,
      "address": "stosolution",
      "value": "申通国际"
    },
    {
      "id": 313,
      "address": "zengyisudi",
      "value": "增益速递"
    },
    {
      "id": 314,
      "address": "anjiekuaidi",
      "value": "青岛安捷快递"
    },
    {
      "id": 315,
      "address": "hac56",
      "value": "瀚朝物流"
    },
    {
      "id": 316,
      "address": "jieborne",
      "value": "捷邦物流"
    },
    {
      "id": 317,
      "address": "uexiex",
      "value": "欧洲UEX"
    },
    {
      "id": 318,
      "address": "yuantongguoji",
      "value": "圆通国际"
    },
    {
      "id": 319,
      "address": "yujiawl",
      "value": "宇佳物流"
    },
    {
      "id": 320,
      "address": "gongsuda",
      "value": "共速达"
    },
    {
      "id": 321,
      "address": "malaysiaems",
      "value": "马来西亚大包、EMS（Malaysia Post(parcel,EMS)）"
    },
    {
      "id": 322,
      "address": "cnws",
      "value": "中国翼"
    },
    {
      "id": 323,
      "address": "quanritongkuaidi",
      "value": "全日通"
    },
    {
      "id": 324,
      "address": "adaexpress",
      "value": "明大快递"
    },
    {
      "id": 325,
      "address": "clsp",
      "value": "CL日中速运"
    },
    {
      "id": 326,
      "address": "haidaibao",
      "value": "海带宝"
    },
    {
      "id": 327,
      "address": "jiazhoumao",
      "value": "加州猫速递"
    },
    {
      "id": 328,
      "address": "sccod",
      "value": "丰程物流"
    },
    {
      "id": 329,
      "address": "dadaoex",
      "value": "大道物流"
    },
    {
      "id": 330,
      "address": "bangsongwuliu",
      "value": "邦送物流"
    },
    {
      "id": 331,
      "address": "hkposten",
      "value": "中国香港(HongKong Post)英文"
    },
    {
      "id": 332,
      "address": "tcat",
      "value": "黑猫宅急便"
    },
    {
      "id": 333,
      "address": "chuanxiwuliu",
      "value": "传喜物流"
    },
    {
      "id": 334,
      "address": "jiacheng",
      "value": "佳成快递"
    },
    {
      "id": 335,
      "address": "lasership",
      "value": "LaserShip"
    },
    {
      "id": 336,
      "address": "ltx",
      "value": "蓝天国际快递"
    },
    {
      "id": 337,
      "address": "sundarexpress",
      "value": "顺达快递"
    },
    {
      "id": 338,
      "address": "xtb",
      "value": "鑫通宝物流"
    },
    {
      "id": 339,
      "address": "eshunda",
      "value": "俄顺达"
    },
    {
      "id": 340,
      "address": "eta100",
      "value": "易达国际速递"
    },
    {
      "id": 341,
      "address": "georgianpost",
      "value": "格鲁吉亚(Georgian Pos）"
    },
    {
      "id": 342,
      "address": "gslexpress",
      "value": "德尚国际速递"
    },
    {
      "id": 343,
      "address": "iyoungspeed",
      "value": "驿扬国际速运"
    },
    {
      "id": 344,
      "address": "sinatone",
      "value": "信联通"
    },
    {
      "id": 345,
      "address": "yiqisong",
      "value": "一起送"
    },
    {
      "id": 346,
      "address": "cncexp",
      "value": "C&C国际速递"
    },
    {
      "id": 347,
      "address": "comexpress",
      "value": "邦通国际"
    },
    {
      "id": 348,
      "address": "dayangwuliu",
      "value": "大洋物流"
    },
    {
      "id": 349,
      "address": "hlyex",
      "value": "好来运"
    },
    {
      "id": 350,
      "address": "ldxpres",
      "value": "林道国际快递-英文"
    },
    {
      "id": 351,
      "address": "sdyoupei",
      "value": "优配速运"
    },
    {
      "id": 352,
      "address": "ynztsy",
      "value": "纵通速运"
    },
    {
      "id": 353,
      "address": "zhongtianwanyun",
      "value": "中天万运"
    },
    {
      "id": 354,
      "address": "airpak",
      "value": "airpak expresss"
    },
    {
      "id": 355,
      "address": "aplus100",
      "value": "美国汉邦快递"
    },
    {
      "id": 356,
      "address": "auex",
      "value": "澳货通"
    },
    {
      "id": 357,
      "address": "bjemstckj",
      "value": "北京EMS"
    },
    {
      "id": 358,
      "address": "buytong",
      "value": "百通物流"
    },
    {
      "id": 359,
      "address": "cameroon",
      "value": "喀麦隆(CAMPOST)"
    },
    {
      "id": 360,
      "address": "dekuncn",
      "value": "德坤物流"
    },
    {
      "id": 361,
      "address": "highsince",
      "value": "Highsince"
    },
    {
      "id": 362,
      "address": "india",
      "value": "印度(India Post)"
    },
    {
      "id": 363,
      "address": "ptt",
      "value": "土耳其"
    },
    {
      "id": 364,
      "address": "quanjitong",
      "value": "全际通"
    },
    {
      "id": 365,
      "address": "shunjiefengda",
      "value": "顺捷丰达"
    },
    {
      "id": 366,
      "address": "vctrans",
      "value": "越中国际物流"
    },
    {
      "id": 367,
      "address": "ytkd",
      "value": "运通中港快递"
    },
    {
      "id": 368,
      "address": "yue777",
      "value": "玥玛速运"
    },
    {
      "id": 369,
      "address": "aosu",
      "value": "澳速物流"
    },
    {
      "id": 370,
      "address": "ceskaposta",
      "value": "捷克（?eská po?ta）"
    },
    {
      "id": 371,
      "address": "chronopostfra",
      "value": "法国大包、EMS-法文（Chronopost France）"
    },
    {
      "id": 372,
      "address": "chuangyi",
      "value": "创一快递"
    },
    {
      "id": 373,
      "address": "cnair",
      "value": "CNAIR"
    },
    {
      "id": 374,
      "address": "fastgoexpress",
      "value": "速派快递"
    },
    {
      "id": 375,
      "address": "feiyuanvipshop",
      "value": "飞远配送"
    },
    {
      "id": 376,
      "address": "huanqiuabc",
      "value": "中国香港环球快运"
    },
    {
      "id": 377,
      "address": "malaysiapost",
      "value": "马来西亚小包（Malaysia Post(Registered)）"
    },
    {
      "id": 378,
      "address": "sfift",
      "value": "十方通物流"
    },
    {
      "id": 379,
      "address": "zjstky",
      "value": "苏通快运"
    },
    {
      "id": 380,
      "address": "finland",
      "value": "芬兰(Itella Posti Oy)"
    },
    {
      "id": 381,
      "address": "gls",
      "value": "GLS"
    },
    {
      "id": 382,
      "address": "jgwl",
      "value": "景光物流"
    },
    {
      "id": 383,
      "address": "junfengguoji",
      "value": "骏丰国际速递"
    },
    {
      "id": 384,
      "address": "lsexpress",
      "value": "6LS EXPRESS"
    },
    {
      "id": 385,
      "address": "nle",
      "value": "NLE"
    },
    {
      "id": 386,
      "address": "quansu",
      "value": "全速物流"
    },
    {
      "id": 387,
      "address": "rwanda",
      "value": "卢旺达(Rwanda i-posita)"
    },
    {
      "id": 388,
      "address": "shangda",
      "value": "上大物流"
    },
    {
      "id": 389,
      "address": "shanghaikuaitong",
      "value": "上海快通"
    },
    {
      "id": 390,
      "address": "shangqiao56",
      "value": "商桥物流"
    },
    {
      "id": 391,
      "address": "shlindao",
      "value": "林道国际快递"
    },
    {
      "id": 392,
      "address": "thailand",
      "value": "泰国（Thailand Thai Post）"
    },
    {
      "id": 393,
      "address": "thaizto",
      "value": "泰国中通ZTO"
    },
    {
      "id": 394,
      "address": "topspeedex",
      "value": "中运全速"
    },
    {
      "id": 395,
      "address": "wondersyd",
      "value": "中邮速递"
    },
    {
      "id": 396,
      "address": "yinjiesudi",
      "value": "银捷速递"
    },
    {
      "id": 397,
      "address": "ytky168",
      "value": "运通快运"
    },
    {
      "id": 398,
      "address": "56kuaiyun",
      "value": "五六快运"
    },
    {
      "id": 399,
      "address": "aolau",
      "value": "AOL澳通速递"
    },
    {
      "id": 400,
      "address": "canpostfr",
      "value": "加拿大邮政"
    },
    {
      "id": 401,
      "address": "cllexpress",
      "value": "澳通华人物流"
    },
    {
      "id": 402,
      "address": "feikangda",
      "value": "飞康达"
    },
    {
      "id": 403,
      "address": "ghtexpress",
      "value": "GHT物流"
    },
    {
      "id": 404,
      "address": "haimengsudi",
      "value": "海盟速递"
    },
    {
      "id": 405,
      "address": "htongexpress",
      "value": "华通快运"
    },
    {
      "id": 406,
      "address": "landmarkglobal",
      "value": "Landmark Global"
    },
    {
      "id": 407,
      "address": "nalexpress",
      "value": "新亚物流"
    },
    {
      "id": 408,
      "address": "polarisexpress",
      "value": "北极星快运"
    },
    {
      "id": 409,
      "address": "postelbe",
      "value": "PostElbe"
    },
    {
      "id": 410,
      "address": "republic",
      "value": "叙利亚(Syrian Post)"
    },
    {
      "id": 411,
      "address": "rfsd",
      "value": "瑞丰速递"
    },
    {
      "id": 412,
      "address": "samoa",
      "value": "萨摩亚(Samoa Post)"
    },
    {
      "id": 413,
      "address": "xianglongyuntong",
      "value": "祥龙运通物流"
    },
    {
      "id": 414,
      "address": "yibangwuliu",
      "value": "一邦速递"
    },
    {
      "id": 415,
      "address": "yuefengwuliu",
      "value": "越丰物流"
    },
    {
      "id": 416,
      "address": "ztong",
      "value": "智通物流"
    },
    {
      "id": 417,
      "address": "abf",
      "value": "ABF"
    },
    {
      "id": 418,
      "address": "auvanda",
      "value": "中联速递"
    },
    {
      "id": 419,
      "address": "benteng",
      "value": "奔腾物流"
    },
    {
      "id": 420,
      "address": "chinapostcb",
      "value": "中邮电商"
    },
    {
      "id": 421,
      "address": "cuckooexpess",
      "value": "布谷鸟速递"
    },
    {
      "id": 422,
      "address": "ecallturn",
      "value": "E跨通"
    },
    {
      "id": 423,
      "address": "emonitoring",
      "value": "波兰小包(Poczta Polska)"
    },
    {
      "id": 424,
      "address": "huaqikuaiyun",
      "value": "华企快运"
    },
    {
      "id": 425,
      "address": "jixianda",
      "value": "急先达"
    },
    {
      "id": 426,
      "address": "ltexp",
      "value": "乐天速递"
    },
    {
      "id": 427,
      "address": "peex",
      "value": "派尔快递"
    },
    {
      "id": 428,
      "address": "rrthk",
      "value": "日日通国际"
    },
    {
      "id": 429,
      "address": "serbia",
      "value": "塞尔维亚(PE Post of Serbia)"
    },
    {
      "id": 430,
      "address": "suijiawuliu",
      "value": "穗佳物流"
    },
    {
      "id": 431,
      "address": "tzky",
      "value": "铁中快运"
    },
    {
      "id": 432,
      "address": "uscbexpress",
      "value": "易境达国际物流"
    },
    {
      "id": 433,
      "address": "wto56kj",
      "value": "温通物流"
    },
    {
      "id": 434,
      "address": "yizhengdasuyun",
      "value": "一正达速运"
    },
    {
      "id": 435,
      "address": "zhonghuanus",
      "value": "中环转运"
    },
    {
      "id": 436,
      "address": "1ziton",
      "value": "一智通"
    },
    {
      "id": 437,
      "address": "adlerlogi",
      "value": "德国雄鹰速递"
    },
    {
      "id": 438,
      "address": "ajexpress",
      "value": "捷记方舟"
    },
    {
      "id": 439,
      "address": "anlexpress",
      "value": "新干线快递"
    },
    {
      "id": 440,
      "address": "bee001",
      "value": "蜜蜂速递"
    },
    {
      "id": 441,
      "address": "ccd",
      "value": "河南次晨达"
    },
    {
      "id": 442,
      "address": "cloudexpress",
      "value": "CE易欧通国际速递"
    },
    {
      "id": 443,
      "address": "euexpress",
      "value": "EU-EXPRESS"
    },
    {
      "id": 444,
      "address": "feibaokuaidi",
      "value": "飞豹快递"
    },
    {
      "id": 445,
      "address": "fox",
      "value": "FOX国际快递"
    },
    {
      "id": 446,
      "address": "gsm",
      "value": "GSM"
    },
    {
      "id": 447,
      "address": "higo",
      "value": "黑狗物流"
    },
    {
      "id": 448,
      "address": "ht22",
      "value": "海淘物流"
    },
    {
      "id": 449,
      "address": "kfwnet",
      "value": "快服务"
    },
    {
      "id": 450,
      "address": "mingliangwuliu",
      "value": "明亮物流"
    },
    {
      "id": 451,
      "address": "oman",
      "value": "阿曼(Oman Post)"
    },
    {
      "id": 452,
      "address": "saiaodi",
      "value": "赛澳递"
    },
    {
      "id": 453,
      "address": "sd138",
      "value": "泰国138国际物流"
    },
    {
      "id": 454,
      "address": "sofast56",
      "value": "嗖一下同城快递"
    },
    {
      "id": 455,
      "address": "sut56",
      "value": "速通物流"
    },
    {
      "id": 456,
      "address": "uzbekistan",
      "value": "乌兹别克斯坦(Post of Uzbekistan)"
    },
    {
      "id": 457,
      "address": "vanuatu",
      "value": "瓦努阿图(Vanuatu Post)"
    },
    {
      "id": 458,
      "address": "wotu",
      "value": "渥途国际速运"
    },
    {
      "id": 459,
      "address": "xipost",
      "value": "西邮寄"
    },
    {
      "id": 460,
      "address": "yuanhhk",
      "value": "远航国际快运"
    },
    {
      "id": 461,
      "address": "yuntong",
      "value": "运通速运"
    },
    {
      "id": 462,
      "address": "adiexpress",
      "value": "安达易国际速递"
    },
    {
      "id": 463,
      "address": "ahdf",
      "value": "德方物流"
    },
    {
      "id": 464,
      "address": "austria",
      "value": "奥地利(Austrian Post)"
    },
    {
      "id": 465,
      "address": "bht",
      "value": "BHT"
    },
    {
      "id": 466,
      "address": "biaojikuaidi",
      "value": "彪记快递"
    },
    {
      "id": 467,
      "address": "chengtong",
      "value": "城通物流"
    },
    {
      "id": 468,
      "address": "chronopostfren",
      "value": "法国大包、EMS-英文(Chronopost France)"
    },
    {
      "id": 469,
      "address": "chszhonghuanguoji",
      "value": "CHS中环国际快递"
    },
    {
      "id": 470,
      "address": "chunfai",
      "value": "中国香港骏辉物流"
    },
    {
      "id": 471,
      "address": "correo",
      "value": "乌拉圭（Correo Uruguayo）"
    },
    {
      "id": 472,
      "address": "dechuangwuliu",
      "value": "深圳德创物流"
    },
    {
      "id": 473,
      "address": "donghanwl",
      "value": "东瀚物流"
    },
    {
      "id": 474,
      "address": "etong",
      "value": "E通速递"
    },
    {
      "id": 475,
      "address": "euguoji",
      "value": "易邮国际"
    },
    {
      "id": 476,
      "address": "gaotieex",
      "value": "高铁快运"
    },
    {
      "id": 477,
      "address": "ge2d",
      "value": "GE2D跨境物流"
    },
    {
      "id": 478,
      "address": "lbbk",
      "value": "立白宝凯物流"
    },
    {
      "id": 479,
      "address": "parcelforcecn",
      "value": "英国邮政大包EMS"
    },
    {
      "id": 480,
      "address": "posta",
      "value": "坦桑尼亚（Tanzania Posts Corporation）"
    },
    {
      "id": 481,
      "address": "postnlpacle",
      "value": "荷兰包裹(PostNL International Parcels)"
    },
    {
      "id": 482,
      "address": "quansutong",
      "value": "全速通"
    },
    {
      "id": 483,
      "address": "shenganwuliu",
      "value": "圣安物流"
    },
    {
      "id": 484,
      "address": "shlexp",
      "value": "SHL畅灵国际物流"
    },
    {
      "id": 485,
      "address": "shunjieda",
      "value": "顺捷达"
    },
    {
      "id": 486,
      "address": "skynetworldwide",
      "value": "skynetworldwide"
    },
    {
      "id": 487,
      "address": "spring56",
      "value": "春风物流"
    },
    {
      "id": 488,
      "address": "trackparcel",
      "value": "track-parcel"
    },
    {
      "id": 489,
      "address": "ubuy",
      "value": "德国优拜物流"
    },
    {
      "id": 490,
      "address": "uspscn",
      "value": "USPSCN"
    },
    {
      "id": 491,
      "address": "vangenexpress",
      "value": "万庚国际速递"
    },
    {
      "id": 492,
      "address": "wykjt",
      "value": "51跨境通"
    },
    {
      "id": 493,
      "address": "xynyc",
      "value": "新元国际"
    },
    {
      "id": 494,
      "address": "yongchangwuliu",
      "value": "永昌物流"
    },
    {
      "id": 495,
      "address": "yourscm",
      "value": "雅澳物流"
    },
    {
      "id": 496,
      "address": "yuandun",
      "value": "远盾物流"
    },
    {
      "id": 497,
      "address": "yyox",
      "value": "邮客全球速递"
    },
    {
      "id": 498,
      "address": "adp",
      "value": "ADP国际快递"
    },
    {
      "id": 499,
      "address": "advancing",
      "value": "安达信"
    },
    {
      "id": 500,
      "address": "agopost",
      "value": "全程快递"
    },
    {
      "id": 501,
      "address": "alog",
      "value": "心怡物流"
    },
    {
      "id": 502,
      "address": "anjie88",
      "value": "安捷物流"
    },
    {
      "id": 503,
      "address": "anposten",
      "value": "爱尔兰(An Post)"
    },
    {
      "id": 504,
      "address": "aplusex",
      "value": "Aplus物流"
    },
    {
      "id": 505,
      "address": "bangbangpost",
      "value": "帮帮发"
    },
    {
      "id": 506,
      "address": "beckygo",
      "value": "佰麒快递"
    },
    {
      "id": 507,
      "address": "bgky100",
      "value": "邦工快运"
    },
    {
      "id": 508,
      "address": "cdek",
      "value": "CDEK"
    },
    {
      "id": 509,
      "address": "chengjisudi",
      "value": "城际速递"
    },
    {
      "id": 510,
      "address": "chinatzx",
      "value": "同舟行物流"
    },
    {
      "id": 511,
      "address": "chunghwa56",
      "value": "中骅物流"
    },
    {
      "id": 512,
      "address": "dcs",
      "value": "DCS"
    },
    {
      "id": 513,
      "address": "dhlpoland",
      "value": "DHL-波兰（DHL Poland）"
    },
    {
      "id": 514,
      "address": "donghong",
      "value": "东红物流"
    },
    {
      "id": 515,
      "address": "dpdgermany",
      "value": "DPD Germany"
    },
    {
      "id": 516,
      "address": "easyexpress",
      "value": "EASY EXPRESS"
    },
    {
      "id": 517,
      "address": "emssouthafrica",
      "value": "南非EMS"
    },
    {
      "id": 518,
      "address": "estes",
      "value": "Estes"
    },
    {
      "id": 519,
      "address": "express7th",
      "value": "7号速递"
    },
    {
      "id": 520,
      "address": "fbkd",
      "value": "飞邦快递"
    },
    {
      "id": 521,
      "address": "fedroad",
      "value": "FedRoad 联邦转运"
    },
    {
      "id": 522,
      "address": "feikuaida",
      "value": "飞快达"
    },
    {
      "id": 523,
      "address": "fenghuangkuaidi",
      "value": "凤凰快递"
    },
    {
      "id": 524,
      "address": "fsexp",
      "value": "全速快递"
    },
    {
      "id": 525,
      "address": "goldjet",
      "value": "高捷快运"
    },
    {
      "id": 526,
      "address": "gtongsudi",
      "value": "广通速递"
    },
    {
      "id": 527,
      "address": "haiwaihuanqiu",
      "value": "海外环球"
    },
    {
      "id": 528,
      "address": "hongjie",
      "value": "宏捷国际物流"
    },
    {
      "id": 529,
      "address": "hongxun",
      "value": "鸿讯物流"
    },
    {
      "id": 530,
      "address": "huiqiangkuaidi",
      "value": "汇强快递"
    },
    {
      "id": 531,
      "address": "israelpost",
      "value": "以色列(Israel Post)"
    },
    {
      "id": 532,
      "address": "kcs",
      "value": "KCS"
    },
    {
      "id": 533,
      "address": "kejie",
      "value": "科捷物流"
    },
    {
      "id": 534,
      "address": "koreapostkr",
      "value": "韩国邮政韩文"
    },
    {
      "id": 535,
      "address": "kuaiyouda",
      "value": "四川快优达速递"
    },
    {
      "id": 536,
      "address": "lanbiaokuaidi",
      "value": "蓝镖快递"
    },
    {
      "id": 537,
      "address": "latvia",
      "value": "拉脱维亚(Latvijas Pasts)"
    },
    {
      "id": 538,
      "address": "lesotho",
      "value": "莱索托(Lesotho Post)"
    },
    {
      "id": 539,
      "address": "lithuania",
      "value": "立陶宛（Lietuvos pa?tas）"
    },
    {
      "id": 540,
      "address": "logistics",
      "value": "華信物流WTO"
    },
    {
      "id": 541,
      "address": "mchy",
      "value": "木春货运"
    },
    {
      "id": 542,
      "address": "minbangsudi",
      "value": "民邦速递"
    },
    {
      "id": 543,
      "address": "morocco",
      "value": "摩洛哥 ( Morocco Post )"
    },
    {
      "id": 544,
      "address": "mrw",
      "value": "MRW"
    },
    {
      "id": 545,
      "address": "nntengda",
      "value": "腾达速递"
    },
    {
      "id": 546,
      "address": "omniva",
      "value": "爱沙尼亚(Eesti Post)"
    },
    {
      "id": 547,
      "address": "pengyuanexpress",
      "value": "鹏远国际速递"
    },
    {
      "id": 548,
      "address": "qbexpress",
      "value": "秦邦快运"
    },
    {
      "id": 549,
      "address": "quanchenkuaidi",
      "value": "全晨快递"
    },
    {
      "id": 550,
      "address": "quantwl",
      "value": "全通快运"
    },
    {
      "id": 551,
      "address": "safexpress",
      "value": "Safexpress"
    },
    {
      "id": 552,
      "address": "santaisudi",
      "value": "三态速递"
    },
    {
      "id": 553,
      "address": "scic",
      "value": "中加国际快递"
    },
    {
      "id": 554,
      "address": "sfau",
      "value": "澳丰速递"
    },
    {
      "id": 555,
      "address": "shunbang",
      "value": "顺邦国际物流"
    },
    {
      "id": 556,
      "address": "sinoex",
      "value": "中外运速递-中文"
    },
    {
      "id": 557,
      "address": "siodemka",
      "value": "Siodemka"
    },
    {
      "id": 558,
      "address": "skynetmalaysia",
      "value": "SkyNet Malaysia"
    },
    {
      "id": 559,
      "address": "slovak",
      "value": "斯洛伐克(Slovenská Posta)"
    },
    {
      "id": 560,
      "address": "southafrican",
      "value": "南非（South African Post Office）"
    },
    {
      "id": 561,
      "address": "speedpost",
      "value": "新加坡EMS、大包(Singapore Speedpost)"
    },
    {
      "id": 562,
      "address": "staryvr",
      "value": "星运快递"
    },
    {
      "id": 563,
      "address": "stkd",
      "value": "顺通快递"
    },
    {
      "id": 564,
      "address": "sucmj",
      "value": "特急便物流"
    },
    {
      "id": 565,
      "address": "szdpex",
      "value": "深圳DPEX"
    },
    {
      "id": 566,
      "address": "uschuaxia",
      "value": "华夏国际速递"
    },
    {
      "id": 567,
      "address": "wenjiesudi",
      "value": "文捷航空"
    },
    {
      "id": 568,
      "address": "winit",
      "value": "万邑通"
    },
    {
      "id": 569,
      "address": "wtdchina",
      "value": "威时沛运货运"
    },
    {
      "id": 570,
      "address": "xilaikd",
      "value": "西安喜来快递"
    },
    {
      "id": 571,
      "address": "yifankd",
      "value": "艺凡快递"
    },
    {
      "id": 572,
      "address": "youjia",
      "value": "友家速递"
    },
    {
      "id": 573,
      "address": "zhichengtongda",
      "value": "至诚通达快递"
    },
    {
      "id": 574,
      "address": "zhongwaiyun",
      "value": "中外运速递"
    },
    {
      "id": 575,
      "address": "zsmhwl",
      "value": "明辉物流"
    },
    {
      "id": 576,
      "address": "adodoxm",
      "value": "澳多多国际速递"
    },
    {
      "id": 577,
      "address": "afghan",
      "value": "阿富汗(Afghan Post)"
    },
    {
      "id": 578,
      "address": "afl",
      "value": "AFL"
    },
    {
      "id": 579,
      "address": "ahkbps",
      "value": "卡邦配送"
    },
    {
      "id": 580,
      "address": "airgtc",
      "value": "航空快递"
    },
    {
      "id": 581,
      "address": "albania",
      "value": "阿尔巴尼亚(Posta shqipatre)"
    },
    {
      "id": 582,
      "address": "aliexpress",
      "value": "无忧物流"
    },
    {
      "id": 583,
      "address": "amazoncnorder",
      "value": "亚马逊中国订单"
    },
    {
      "id": 584,
      "address": "amcnorder",
      "value": "amazon-国内订单"
    },
    {
      "id": 585,
      "address": "amusorder",
      "value": "amazon-国际订单"
    },
    {
      "id": 586,
      "address": "apgecommerce",
      "value": "apgecommerce"
    },
    {
      "id": 587,
      "address": "ariesfar",
      "value": "艾瑞斯远"
    },
    {
      "id": 588,
      "address": "aruba",
      "value": "阿鲁巴[荷兰]（Post Aruba）"
    },
    {
      "id": 589,
      "address": "auvexpress",
      "value": "AUV国际快递"
    },
    {
      "id": 590,
      "address": "axexpress",
      "value": "澳新物流"
    },
    {
      "id": 591,
      "address": "azerbaijan",
      "value": "阿塞拜疆EMS(EMS AzerExpressPost)"
    },
    {
      "id": 592,
      "address": "bahrain",
      "value": "巴林(Bahrain Post)"
    },
    {
      "id": 593,
      "address": "bangladesh",
      "value": "孟加拉国(EMS)"
    },
    {
      "id": 594,
      "address": "baotongkd",
      "value": "宝通快递"
    },
    {
      "id": 595,
      "address": "baoxianda",
      "value": "报通快递"
    },
    {
      "id": 596,
      "address": "barbados",
      "value": "巴巴多斯(Barbados Post)"
    },
    {
      "id": 597,
      "address": "bcwelt",
      "value": "BCWELT"
    },
    {
      "id": 598,
      "address": "belgiumpost",
      "value": "比利时(Belgium Post)"
    },
    {
      "id": 599,
      "address": "belize",
      "value": "伯利兹(Belize Postal)"
    },
    {
      "id": 600,
      "address": "belpost",
      "value": "白俄罗斯(Belpochta)"
    },
    {
      "id": 601,
      "address": "benniao",
      "value": "笨鸟国际"
    },
    {
      "id": 602,
      "address": "bester",
      "value": "飛斯特"
    },
    {
      "id": 603,
      "address": "bjqywl",
      "value": "青云物流"
    },
    {
      "id": 604,
      "address": "bjxsrd",
      "value": "鑫锐达"
    },
    {
      "id": 605,
      "address": "bluedart",
      "value": "BlueDart"
    },
    {
      "id": 606,
      "address": "bmlchina",
      "value": "标杆物流"
    },
    {
      "id": 607,
      "address": "bohei",
      "value": "波黑(JP BH Posta)"
    },
    {
      "id": 608,
      "address": "bolivia",
      "value": "玻利维亚"
    },
    {
      "id": 609,
      "address": "borderguru",
      "value": "BorderGuru"
    },
    {
      "id": 610,
      "address": "botspost",
      "value": "博茨瓦纳"
    },
    {
      "id": 611,
      "address": "bphchina",
      "value": "速方(Sufast)"
    },
    {
      "id": 612,
      "address": "brazilposten",
      "value": "巴西(Brazil Post/Correios)"
    },
    {
      "id": 613,
      "address": "brunei",
      "value": "文莱(Brunei Postal)"
    },
    {
      "id": 614,
      "address": "btexpress",
      "value": "邦泰快运"
    },
    {
      "id": 615,
      "address": "byht",
      "value": "展勤快递"
    },
    {
      "id": 616,
      "address": "caledonia",
      "value": "新喀里多尼亚[法国](New Caledonia)"
    },
    {
      "id": 617,
      "address": "cambodia",
      "value": "柬埔寨(Cambodia Post)"
    },
    {
      "id": 618,
      "address": "camekong",
      "value": "到了港"
    },
    {
      "id": 619,
      "address": "cangspeed",
      "value": "仓鼠快递"
    },
    {
      "id": 620,
      "address": "canhold",
      "value": "能装能送"
    },
    {
      "id": 621,
      "address": "canpar",
      "value": "Canpar"
    },
    {
      "id": 622,
      "address": "cargolux",
      "value": "卢森堡航空"
    },
    {
      "id": 623,
      "address": "cbo56",
      "value": "钏博物流"
    },
    {
      "id": 624,
      "address": "cex",
      "value": "城铁速递"
    },
    {
      "id": 625,
      "address": "changwooair",
      "value": "昌宇国际"
    },
    {
      "id": 626,
      "address": "changyuwuliu",
      "value": "长宇物流"
    },
    {
      "id": 627,
      "address": "chengda",
      "value": "成达国际速递"
    },
    {
      "id": 628,
      "address": "chengji",
      "value": "城际快递"
    },
    {
      "id": 629,
      "address": "chile",
      "value": "智利(Correos Chile)"
    },
    {
      "id": 630,
      "address": "chinasqk",
      "value": "SQK国际速递"
    },
    {
      "id": 631,
      "address": "chllog",
      "value": "嘉荣物流"
    },
    {
      "id": 632,
      "address": "chronopostport",
      "value": "Chronopost Portugal"
    },
    {
      "id": 633,
      "address": "city56",
      "value": "城市映急"
    },
    {
      "id": 634,
      "address": "cjkoreaexpress",
      "value": "大韩通运"
    },
    {
      "id": 635,
      "address": "ckeex",
      "value": "城晓国际快递"
    },
    {
      "id": 636,
      "address": "cnexps",
      "value": "CNE"
    },
    {
      "id": 637,
      "address": "cnup",
      "value": "CNUP 中联邮"
    },
    {
      "id": 638,
      "address": "colombia",
      "value": "哥伦比亚(4-72 La Red Postal de Colombia)"
    },
    {
      "id": 639,
      "address": "correios",
      "value": "莫桑比克（Correios de Moçambique）"
    },
    {
      "id": 640,
      "address": "correoargentino",
      "value": "阿根廷(Correo Argentina)"
    },
    {
      "id": 641,
      "address": "correos",
      "value": "哥斯达黎加(Correos de Costa Rica)"
    },
    {
      "id": 642,
      "address": "cosco",
      "value": "中远e环球"
    },
    {
      "id": 643,
      "address": "cpsair",
      "value": "华中快递"
    },
    {
      "id": 644,
      "address": "cqxingcheng",
      "value": "重庆星程快递"
    },
    {
      "id": 645,
      "address": "csxss",
      "value": "新时速物流"
    },
    {
      "id": 646,
      "address": "ctoexp",
      "value": "泰国中通CTO"
    },
    {
      "id": 647,
      "address": "cypruspost",
      "value": "塞浦路斯(Cyprus Post)"
    },
    {
      "id": 648,
      "address": "czwlyn",
      "value": "云南诚中物流"
    },
    {
      "id": 649,
      "address": "dasu",
      "value": "达速物流"
    },
    {
      "id": 650,
      "address": "deguo8elog",
      "value": "德国八易转运"
    },
    {
      "id": 651,
      "address": "deltec",
      "value": "Deltec Courier"
    },
    {
      "id": 652,
      "address": "desworks",
      "value": "澳行快递"
    },
    {
      "id": 653,
      "address": "dfkuaidi",
      "value": "东风快递"
    },
    {
      "id": 654,
      "address": "dfpost",
      "value": "达方物流"
    },
    {
      "id": 655,
      "address": "dhlecommerce",
      "value": "dhl小包"
    },
    {
      "id": 656,
      "address": "dhlhk",
      "value": "DHL HK"
    },
    {
      "id": 657,
      "address": "dhlnetherlands",
      "value": "DHL-荷兰（DHL Netherlands）"
    },
    {
      "id": 658,
      "address": "di5pll",
      "value": "递五方云仓"
    },
    {
      "id": 659,
      "address": "diantongkuaidi",
      "value": "店通快递"
    },
    {
      "id": 660,
      "address": "dianyi",
      "value": "云南滇驿物流"
    },
    {
      "id": 661,
      "address": "didasuyun",
      "value": "递达速运"
    },
    {
      "id": 662,
      "address": "dindon",
      "value": "叮咚澳洲转运"
    },
    {
      "id": 663,
      "address": "dingdong",
      "value": "叮咚快递"
    },
    {
      "id": 664,
      "address": "directlink",
      "value": "Direct Link"
    },
    {
      "id": 665,
      "address": "disifangau",
      "value": "递四方澳洲"
    },
    {
      "id": 666,
      "address": "disifangus",
      "value": "递四方美国"
    },
    {
      "id": 667,
      "address": "djy56",
      "value": "天翔东捷运"
    },
    {
      "id": 668,
      "address": "dpdpoland",
      "value": "DPD Poland"
    },
    {
      "id": 669,
      "address": "dtdcindia",
      "value": "DTDC India"
    },
    {
      "id": 670,
      "address": "duodao56",
      "value": "duodao56"
    },
    {
      "id": 671,
      "address": "ealceair",
      "value": "东方航空物流"
    },
    {
      "id": 672,
      "address": "ecfirstclass",
      "value": "EC-Firstclass"
    },
    {
      "id": 673,
      "address": "ecmsglobal",
      "value": "ECMS Express"
    },
    {
      "id": 674,
      "address": "ecotransite",
      "value": "东西E全运"
    },
    {
      "id": 675,
      "address": "ecuador",
      "value": "厄瓜多尔(Correos del Ecuador)"
    },
    {
      "id": 676,
      "address": "edaeuexpress",
      "value": "易达快运"
    },
    {
      "id": 677,
      "address": "edlogistics",
      "value": "益递物流"
    },
    {
      "id": 678,
      "address": "edragon",
      "value": "龙象国际物流"
    },
    {
      "id": 679,
      "address": "egypt",
      "value": "埃及（Egypt Post）"
    },
    {
      "id": 680,
      "address": "el56",
      "value": "易联通达"
    },
    {
      "id": 681,
      "address": "elta",
      "value": "希腊包裹（ELTA Hellenic Post）"
    },
    {
      "id": 682,
      "address": "eltahell",
      "value": "希腊EMS（ELTA Courier）"
    },
    {
      "id": 683,
      "address": "emirates",
      "value": "阿联酋(Emirates Post)"
    },
    {
      "id": 684,
      "address": "emms",
      "value": "澳州顺风快递"
    },
    {
      "id": 685,
      "address": "emsluqu",
      "value": "高考通知书"
    },
    {
      "id": 686,
      "address": "emsukraine",
      "value": "乌克兰EMS(EMS Ukraine)"
    },
    {
      "id": 687,
      "address": "emsukrainecn",
      "value": "乌克兰EMS-中文(EMS Ukraine)"
    },
    {
      "id": 688,
      "address": "england",
      "value": "英国(大包,EMS)"
    },
    {
      "id": 689,
      "address": "epspost",
      "value": "联众国际"
    },
    {
      "id": 690,
      "address": "est365",
      "value": "东方汇"
    },
    {
      "id": 691,
      "address": "estafeta",
      "value": "Estafeta"
    },
    {
      "id": 692,
      "address": "ethiopia",
      "value": "埃塞俄比亚(Ethiopian postal)"
    },
    {
      "id": 693,
      "address": "eucnrail",
      "value": "中欧国际物流"
    },
    {
      "id": 694,
      "address": "eucpost",
      "value": "德国 EUC POST"
    },
    {
      "id": 695,
      "address": "europeanecom",
      "value": "europeanecom"
    },
    {
      "id": 696,
      "address": "eusacn",
      "value": "优莎速运"
    },
    {
      "id": 697,
      "address": "excocotree",
      "value": "可可树美中速运"
    },
    {
      "id": 698,
      "address": "expressplus",
      "value": "澳洲新干线快递"
    },
    {
      "id": 699,
      "address": "exsuda",
      "value": "E速达"
    },
    {
      "id": 700,
      "address": "ezhuanyuan",
      "value": "易转运"
    },
    {
      "id": 701,
      "address": "fandaguoji",
      "value": "颿达国际快递-英文"
    },
    {
      "id": 702,
      "address": "fardarww",
      "value": "颿达国际快递"
    },
    {
      "id": 703,
      "address": "fastontime",
      "value": "加拿大联通快运"
    },
    {
      "id": 704,
      "address": "fecobv",
      "value": "丰客物流"
    },
    {
      "id": 705,
      "address": "fedexuk",
      "value": "FedEx-英国件（FedEx UK)"
    },
    {
      "id": 706,
      "address": "fedexukcn",
      "value": "FedEx-英国件"
    },
    {
      "id": 707,
      "address": "feihukuaidi",
      "value": "飞狐快递"
    },
    {
      "id": 708,
      "address": "fiji",
      "value": "斐济(Fiji Post)"
    },
    {
      "id": 709,
      "address": "flowerkd",
      "value": "花瓣转运"
    },
    {
      "id": 710,
      "address": "flysman",
      "value": "飞力士物流"
    },
    {
      "id": 711,
      "address": "ftky365",
      "value": "丰通快运"
    },
    {
      "id": 712,
      "address": "ftlexpress",
      "value": "法翔速运"
    },
    {
      "id": 713,
      "address": "fyex",
      "value": "飞云快递系统"
    },
    {
      "id": 714,
      "address": "gansuandi",
      "value": "甘肃安的快递"
    },
    {
      "id": 715,
      "address": "gaticn",
      "value": "Gati-中文"
    },
    {
      "id": 716,
      "address": "gatien",
      "value": "Gati-英文"
    },
    {
      "id": 717,
      "address": "gatikwe",
      "value": "Gati-KWE"
    },
    {
      "id": 718,
      "address": "gda",
      "value": "安的快递"
    },
    {
      "id": 719,
      "address": "gdct56",
      "value": "广东诚通物流"
    },
    {
      "id": 720,
      "address": "gdqwwl",
      "value": "全网物流"
    },
    {
      "id": 721,
      "address": "gdrz58",
      "value": "容智快运"
    },
    {
      "id": 722,
      "address": "gdxp",
      "value": "新鹏快递"
    },
    {
      "id": 723,
      "address": "ghl",
      "value": "环创物流"
    },
    {
      "id": 724,
      "address": "gibraltar",
      "value": "直布罗陀[英国]( Royal Gibraltar Post)"
    },
    {
      "id": 725,
      "address": "gjwl",
      "value": "冠捷物流"
    },
    {
      "id": 726,
      "address": "globaltracktrace",
      "value": "globaltracktrace"
    },
    {
      "id": 727,
      "address": "gml",
      "value": "英脉物流"
    },
    {
      "id": 728,
      "address": "gotoubi",
      "value": "UBI Australia"
    },
    {
      "id": 729,
      "address": "greenland",
      "value": "格陵兰[丹麦]（TELE Greenland A/S）"
    },
    {
      "id": 730,
      "address": "grivertek",
      "value": "潍鸿"
    },
    {
      "id": 731,
      "address": "gscq365",
      "value": "哥士传奇速递"
    },
    {
      "id": 732,
      "address": "gswtkd",
      "value": "万通快递"
    },
    {
      "id": 733,
      "address": "gtgogo",
      "value": "GT国际快运"
    },
    {
      "id": 734,
      "address": "gts",
      "value": "GTS快递"
    },
    {
      "id": 735,
      "address": "guangdongtonglu",
      "value": "广东通路"
    },
    {
      "id": 736,
      "address": "guanting",
      "value": "冠庭国际物流"
    },
    {
      "id": 737,
      "address": "guosong",
      "value": "国送快运"
    },
    {
      "id": 738,
      "address": "gvpexpress",
      "value": "宏观国际快递"
    },
    {
      "id": 739,
      "address": "gzxingcheng",
      "value": "贵州星程快递"
    },
    {
      "id": 740,
      "address": "haihongmmb",
      "value": "海红for买卖宝"
    },
    {
      "id": 741,
      "address": "haimibuy",
      "value": "海米派物流"
    },
    {
      "id": 742,
      "address": "haixingqiao",
      "value": "海星桥快递"
    },
    {
      "id": 743,
      "address": "handboy",
      "value": "汉邦国际速递"
    },
    {
      "id": 744,
      "address": "hangyu",
      "value": "航宇快递"
    },
    {
      "id": 745,
      "address": "haoshengwuliu",
      "value": "昊盛物流"
    },
    {
      "id": 746,
      "address": "haoyoukuai",
      "value": "好又快物流"
    },
    {
      "id": 747,
      "address": "happylink",
      "value": "开心快递"
    },
    {
      "id": 748,
      "address": "haypost",
      "value": "亚美尼亚(Haypost-Armenian Postal)"
    },
    {
      "id": 749,
      "address": "hengrui56",
      "value": "恒瑞物流"
    },
    {
      "id": 750,
      "address": "hexinexpress",
      "value": "合心速递"
    },
    {
      "id": 751,
      "address": "hgy56",
      "value": "环国运物流"
    },
    {
      "id": 752,
      "address": "hhair56",
      "value": "华瀚快递"
    },
    {
      "id": 753,
      "address": "hipito",
      "value": "海派通"
    },
    {
      "id": 754,
      "address": "hitaoe",
      "value": "Hi淘易快递"
    },
    {
      "id": 755,
      "address": "hjs",
      "value": "猴急送"
    },
    {
      "id": 756,
      "address": "hkems",
      "value": "云邮跨境快递"
    },
    {
      "id": 757,
      "address": "hlkytj",
      "value": "互联快运"
    },
    {
      "id": 758,
      "address": "hlpgyl",
      "value": "共联配"
    },
    {
      "id": 759,
      "address": "hltop",
      "value": "海联快递"
    },
    {
      "id": 760,
      "address": "hmus",
      "value": "华美快递"
    },
    {
      "id": 761,
      "address": "hnfy",
      "value": "飞鹰物流"
    },
    {
      "id": 762,
      "address": "hnqst",
      "value": "河南全速通"
    },
    {
      "id": 763,
      "address": "hnssd56",
      "value": "顺时达物流"
    },
    {
      "id": 764,
      "address": "homexpress",
      "value": "居家通"
    },
    {
      "id": 765,
      "address": "hongbeixin",
      "value": "红背心"
    },
    {
      "id": 766,
      "address": "hongpinwuliu",
      "value": "宏品物流"
    },
    {
      "id": 767,
      "address": "hongywl",
      "value": "红远物流"
    },
    {
      "id": 768,
      "address": "hqtd",
      "value": "环球通达"
    },
    {
      "id": 769,
      "address": "hrbzykd",
      "value": "卓烨快递"
    },
    {
      "id": 770,
      "address": "hre",
      "value": "高铁速递"
    },
    {
      "id": 771,
      "address": "hrvatska",
      "value": "克罗地亚（Hrvatska Posta）"
    },
    {
      "id": 772,
      "address": "hsgtsd",
      "value": "海硕高铁速递"
    },
    {
      "id": 773,
      "address": "htwd",
      "value": "华通务达物流"
    },
    {
      "id": 774,
      "address": "huada",
      "value": "华达快运"
    },
    {
      "id": 775,
      "address": "huandonglg",
      "value": "环东物流"
    },
    {
      "id": 776,
      "address": "huilian",
      "value": "辉联物流"
    },
    {
      "id": 777,
      "address": "humpline",
      "value": "驼峰国际"
    },
    {
      "id": 778,
      "address": "hungary",
      "value": "匈牙利（Magyar Posta）"
    },
    {
      "id": 779,
      "address": "huoban",
      "value": "兰州伙伴物流"
    },
    {
      "id": 780,
      "address": "hutongwuliu",
      "value": "户通物流"
    },
    {
      "id": 781,
      "address": "hyeship",
      "value": "鸿远物流"
    },
    {
      "id": 782,
      "address": "hyk",
      "value": "上海昊宏国际货物"
    },
    {
      "id": 783,
      "address": "hzpl",
      "value": "华航快递"
    },
    {
      "id": 784,
      "address": "ibenben",
      "value": "途鲜物流"
    },
    {
      "id": 785,
      "address": "ibuy8",
      "value": "爱拜物流"
    },
    {
      "id": 786,
      "address": "iceland",
      "value": "冰岛(Iceland Post)"
    },
    {
      "id": 787,
      "address": "idada",
      "value": "大达物流"
    },
    {
      "id": 788,
      "address": "iexpress",
      "value": "iExpress"
    },
    {
      "id": 789,
      "address": "ilogen",
      "value": "logen路坚"
    },
    {
      "id": 790,
      "address": "ilyang",
      "value": "ILYANG"
    },
    {
      "id": 791,
      "address": "imlb2c",
      "value": "艾姆勒"
    },
    {
      "id": 792,
      "address": "indonesia",
      "value": "印度尼西亚EMS(Pos Indonesia-EMS)"
    },
    {
      "id": 793,
      "address": "inposdom",
      "value": "多米尼加（INPOSDOM – Instituto Postal Dominicano）"
    },
    {
      "id": 794,
      "address": "interlink",
      "value": "Interlink Express"
    },
    {
      "id": 795,
      "address": "iran",
      "value": "伊朗（Iran Post）"
    },
    {
      "id": 796,
      "address": "ireland",
      "value": "爱尔兰(An Post)"
    },
    {
      "id": 797,
      "address": "italysad",
      "value": "Italy SDA"
    },
    {
      "id": 798,
      "address": "jamaicapost",
      "value": "牙买加（Jamaica Post）"
    },
    {
      "id": 799,
      "address": "jcex",
      "value": "jcex"
    },
    {
      "id": 800,
      "address": "jcsuda",
      "value": "嘉诚速达"
    },
    {
      "id": 801,
      "address": "jdexpressusa",
      "value": "骏达快递"
    },
    {
      "id": 802,
      "address": "jdiex",
      "value": "JDIEX"
    },
    {
      "id": 803,
      "address": "jdpplus",
      "value": "急递"
    },
    {
      "id": 804,
      "address": "jerseypost",
      "value": "泽西岛"
    },
    {
      "id": 805,
      "address": "jetexpressgroup",
      "value": "澳速通国际速递"
    },
    {
      "id": 806,
      "address": "jiajiatong56",
      "value": "佳家通货运"
    },
    {
      "id": 807,
      "address": "jiajikuaidi",
      "value": "佳吉快递"
    },
    {
      "id": 808,
      "address": "jiguang",
      "value": "极光转运"
    },
    {
      "id": 809,
      "address": "jinchengwuliu",
      "value": "锦程物流"
    },
    {
      "id": 810,
      "address": "jindawuliu",
      "value": "金大物流"
    },
    {
      "id": 811,
      "address": "jintongkd",
      "value": "劲通快递"
    },
    {
      "id": 812,
      "address": "jinyuekuaidi",
      "value": "晋越快递"
    },
    {
      "id": 813,
      "address": "jiugong",
      "value": "九宫物流"
    },
    {
      "id": 814,
      "address": "jiuyicn",
      "value": "久易快递"
    },
    {
      "id": 815,
      "address": "jixiangyouau",
      "value": "吉祥邮（澳洲）"
    },
    {
      "id": 816,
      "address": "jjx888",
      "value": "佳捷翔物流"
    },
    {
      "id": 817,
      "address": "jordan",
      "value": "约旦(Jordan Post)"
    },
    {
      "id": 818,
      "address": "jsexpress",
      "value": "骏绅物流"
    },
    {
      "id": 819,
      "address": "juwu",
      "value": "聚物物流"
    },
    {
      "id": 820,
      "address": "juzhongda",
      "value": "聚中大"
    },
    {
      "id": 821,
      "address": "kangliwuliu",
      "value": "康力物流"
    },
    {
      "id": 822,
      "address": "kaolaexpress",
      "value": "考拉国际速递"
    },
    {
      "id": 823,
      "address": "kazpost",
      "value": "哈萨克斯坦(Kazpost)"
    },
    {
      "id": 824,
      "address": "kenya",
      "value": "肯尼亚(POSTA KENYA)"
    },
    {
      "id": 825,
      "address": "khzto",
      "value": "柬埔寨中通"
    },
    {
      "id": 826,
      "address": "koali",
      "value": "番薯国际货运"
    },
    {
      "id": 827,
      "address": "krtao",
      "value": "淘韩国际快递"
    },
    {
      "id": 828,
      "address": "ksudi",
      "value": "快速递"
    },
    {
      "id": 829,
      "address": "kuai8",
      "value": "快8速运"
    },
    {
      "id": 830,
      "address": "kuaidawuliu",
      "value": "快达物流"
    },
    {
      "id": 831,
      "address": "kuaitao",
      "value": "快淘快递"
    },
    {
      "id": 832,
      "address": "kxda",
      "value": "凯信达"
    },
    {
      "id": 833,
      "address": "kyrgyzpost",
      "value": "吉尔吉斯斯坦(Kyrgyz Post)"
    },
    {
      "id": 834,
      "address": "kyue",
      "value": "跨跃国际"
    },
    {
      "id": 835,
      "address": "lanhukuaidi",
      "value": "蓝弧快递"
    },
    {
      "id": 836,
      "address": "lao",
      "value": "老挝(Lao Express)"
    },
    {
      "id": 837,
      "address": "laposte",
      "value": "塞内加尔"
    },
    {
      "id": 838,
      "address": "lasy56",
      "value": "林安物流"
    },
    {
      "id": 839,
      "address": "ledii",
      "value": "乐递供应链"
    },
    {
      "id": 840,
      "address": "lejiedi",
      "value": "乐捷递"
    },
    {
      "id": 841,
      "address": "leopard",
      "value": "云豹国际货运"
    },
    {
      "id": 842,
      "address": "letseml",
      "value": "美联快递"
    },
    {
      "id": 843,
      "address": "lfexpress",
      "value": "龙枫国际快递"
    },
    {
      "id": 844,
      "address": "lgs",
      "value": "lazada"
    },
    {
      "id": 845,
      "address": "lianbangkuaidien",
      "value": "联邦快递-英文"
    },
    {
      "id": 846,
      "address": "lianyun",
      "value": "联运快递"
    },
    {
      "id": 847,
      "address": "libanpost",
      "value": "黎巴嫩(Liban Post)"
    },
    {
      "id": 848,
      "address": "linex",
      "value": "Linex"
    },
    {
      "id": 849,
      "address": "lishi",
      "value": "丽狮物流"
    },
    {
      "id": 850,
      "address": "lmfex",
      "value": "良藤国际速递"
    },
    {
      "id": 851,
      "address": "longfx",
      "value": "龙飞祥快递"
    },
    {
      "id": 852,
      "address": "longlangkuaidi",
      "value": "隆浪快递"
    },
    {
      "id": 853,
      "address": "longvast",
      "value": "长风物流"
    },
    {
      "id": 854,
      "address": "lqht",
      "value": "恒通快递"
    },
    {
      "id": 855,
      "address": "ltparcel",
      "value": "联通快递"
    },
    {
      "id": 856,
      "address": "lundao",
      "value": "论道国际物流"
    },
    {
      "id": 857,
      "address": "lutong",
      "value": "鲁通快运"
    },
    {
      "id": 858,
      "address": "luxembourg",
      "value": "卢森堡(Luxembourg Post)"
    },
    {
      "id": 859,
      "address": "lwe",
      "value": "LWE"
    },
    {
      "id": 860,
      "address": "macedonia",
      "value": "马其顿(Macedonian Post)"
    },
    {
      "id": 861,
      "address": "macroexpressco",
      "value": "ME物流"
    },
    {
      "id": 862,
      "address": "mailikuaidi",
      "value": "麦力快递"
    },
    {
      "id": 863,
      "address": "mailongdy",
      "value": "迈隆递运"
    },
    {
      "id": 864,
      "address": "maldives",
      "value": "马尔代夫(Maldives Post)"
    },
    {
      "id": 865,
      "address": "malta",
      "value": "马耳他（Malta Post）"
    },
    {
      "id": 866,
      "address": "mangguo",
      "value": "芒果速递"
    },
    {
      "id": 867,
      "address": "mantoo",
      "value": "优能物流"
    },
    {
      "id": 868,
      "address": "mapleexpress",
      "value": "今枫国际快运"
    },
    {
      "id": 869,
      "address": "mauritius",
      "value": "毛里求斯(Mauritius Post)"
    },
    {
      "id": 870,
      "address": "meibang",
      "value": "美邦国际快递"
    },
    {
      "id": 871,
      "address": "meidaexpress",
      "value": "美达快递"
    },
    {
      "id": 872,
      "address": "meitai",
      "value": "美泰物流"
    },
    {
      "id": 873,
      "address": "mexico",
      "value": "墨西哥（Correos de Mexico）"
    },
    {
      "id": 874,
      "address": "mexicodenda",
      "value": "Mexico Senda Express"
    },
    {
      "id": 875,
      "address": "milkyway",
      "value": "银河物流"
    },
    {
      "id": 876,
      "address": "minshengkuaidi",
      "value": "闽盛快递"
    },
    {
      "id": 877,
      "address": "mjexp",
      "value": "美龙快递"
    },
    {
      "id": 878,
      "address": "mmlogi",
      "value": "猛犸速递"
    },
    {
      "id": 879,
      "address": "moldova",
      "value": "摩尔多瓦(Posta Moldovei)"
    },
    {
      "id": 880,
      "address": "mongolpost",
      "value": "蒙古国(Mongol Post)"
    },
    {
      "id": 881,
      "address": "montenegro",
      "value": "黑山(Posta Crne Gore)"
    },
    {
      "id": 882,
      "address": "mosuda",
      "value": "魔速达"
    },
    {
      "id": 883,
      "address": "multipack",
      "value": "Mexico Multipack"
    },
    {
      "id": 884,
      "address": "mxe56",
      "value": "中俄速通（淼信）"
    },
    {
      "id": 885,
      "address": "myhermes",
      "value": "MyHermes"
    },
    {
      "id": 886,
      "address": "namibia",
      "value": "纳米比亚(NamPost)"
    },
    {
      "id": 887,
      "address": "nedahm",
      "value": "红马速递"
    },
    {
      "id": 888,
      "address": "nell",
      "value": "尼尔快递"
    },
    {
      "id": 889,
      "address": "nepalpost",
      "value": "尼泊尔（Nepal Postal Services）"
    },
    {
      "id": 890,
      "address": "nigerianpost",
      "value": "尼日利亚(Nigerian Postal)"
    },
    {
      "id": 891,
      "address": "njhaobo",
      "value": "浩博物流"
    },
    {
      "id": 892,
      "address": "nlebv",
      "value": "亚欧专线"
    },
    {
      "id": 893,
      "address": "nmhuahe",
      "value": "华赫物流"
    },
    {
      "id": 894,
      "address": "novaposhta",
      "value": "Nova Poshta"
    },
    {
      "id": 895,
      "address": "nuoer",
      "value": "诺尔国际物流"
    },
    {
      "id": 896,
      "address": "nuoyaao",
      "value": "偌亚奥国际快递"
    },
    {
      "id": 897,
      "address": "nzzto",
      "value": "新西兰中通"
    },
    {
      "id": 898,
      "address": "oborexpress",
      "value": "OBOR Express"
    },
    {
      "id": 899,
      "address": "ocaargen",
      "value": "OCA Argentina"
    },
    {
      "id": 900,
      "address": "onway",
      "value": "昂威物流"
    },
    {
      "id": 901,
      "address": "opek",
      "value": "OPEK"
    },
    {
      "id": 902,
      "address": "otobv",
      "value": "中欧快运"
    },
    {
      "id": 903,
      "address": "overseaex",
      "value": "波音速递"
    },
    {
      "id": 904,
      "address": "pakistan",
      "value": "巴基斯坦(Pakistan Post)"
    },
    {
      "id": 905,
      "address": "paraguay",
      "value": "巴拉圭(Correo Paraguayo)"
    },
    {
      "id": 906,
      "address": "parcelchina",
      "value": "诚一物流"
    },
    {
      "id": 907,
      "address": "pdstow",
      "value": "全球速递"
    },
    {
      "id": 908,
      "address": "peisihuoyunkuaidi",
      "value": "配思货运"
    },
    {
      "id": 909,
      "address": "peixingwuliu",
      "value": "陪行物流"
    },
    {
      "id": 910,
      "address": "pengcheng",
      "value": "鹏程快递"
    },
    {
      "id": 911,
      "address": "peru",
      "value": "秘鲁(SERPOST)"
    },
    {
      "id": 912,
      "address": "pfcexpress",
      "value": "皇家物流"
    },
    {
      "id": 913,
      "address": "phlpost",
      "value": "菲律宾（Philippine Postal）"
    },
    {
      "id": 914,
      "address": "pinsuxinda",
      "value": "品速心达快递"
    },
    {
      "id": 915,
      "address": "pioneer",
      "value": "先锋国际快递"
    },
    {
      "id": 916,
      "address": "portugalctt",
      "value": "葡萄牙（Portugal CTT）"
    },
    {
      "id": 917,
      "address": "portugalseur",
      "value": "Portugal Seur"
    },
    {
      "id": 918,
      "address": "postenab",
      "value": "PostNord(Posten AB)"
    },
    {
      "id": 919,
      "address": "postennorge",
      "value": "挪威（Posten Norge）"
    },
    {
      "id": 920,
      "address": "postnlchina",
      "value": "荷兰邮政-中国件"
    },
    {
      "id": 921,
      "address": "postpng",
      "value": "巴布亚新几内亚(PNG Post)"
    },
    {
      "id": 922,
      "address": "purolator",
      "value": "Purolator"
    },
    {
      "id": 923,
      "address": "pzhjst",
      "value": "急顺通"
    },
    {
      "id": 924,
      "address": "qdants",
      "value": "ANTS EXPRESS"
    },
    {
      "id": 925,
      "address": "qesd",
      "value": "7E速递"
    },
    {
      "id": 926,
      "address": "qianli",
      "value": "千里速递"
    },
    {
      "id": 927,
      "address": "qpost",
      "value": "卡塔尔（Qatar Post）"
    },
    {
      "id": 928,
      "address": "qskdyxgs",
      "value": "千顺快递"
    },
    {
      "id": 929,
      "address": "quanchuan56",
      "value": "全川物流"
    },
    {
      "id": 930,
      "address": "quantium",
      "value": "Quantium"
    },
    {
      "id": 931,
      "address": "quanxintong",
      "value": "全信通快递"
    },
    {
      "id": 932,
      "address": "qzx56",
      "value": "全之鑫物流"
    },
    {
      "id": 933,
      "address": "redexpress",
      "value": "Red Express"
    },
    {
      "id": 934,
      "address": "riyuwuliu",
      "value": "日昱物流"
    },
    {
      "id": 935,
      "address": "rokin",
      "value": "荣庆物流"
    },
    {
      "id": 936,
      "address": "romanian",
      "value": "罗马尼亚（Posta Romanian）"
    },
    {
      "id": 937,
      "address": "rpx",
      "value": "rpx"
    },
    {
      "id": 938,
      "address": "rrskx",
      "value": "日日顺快线"
    },
    {
      "id": 939,
      "address": "ruexp",
      "value": "捷网俄全通"
    },
    {
      "id": 940,
      "address": "ruidaex",
      "value": "瑞达国际速递"
    },
    {
      "id": 941,
      "address": "runhengfeng",
      "value": "全时速运"
    },
    {
      "id": 942,
      "address": "rytsd",
      "value": "日益通速递"
    },
    {
      "id": 943,
      "address": "s2c",
      "value": "S2C"
    },
    {
      "id": 944,
      "address": "sanshengco",
      "value": "三盛快递"
    },
    {
      "id": 945,
      "address": "saudipost",
      "value": "沙特阿拉伯(Saudi Post)"
    },
    {
      "id": 946,
      "address": "scxingcheng",
      "value": "四川星程快递"
    },
    {
      "id": 947,
      "address": "sczpds",
      "value": "速呈"
    },
    {
      "id": 948,
      "address": "sdsy888",
      "value": "首达速运"
    },
    {
      "id": 949,
      "address": "selektvracht",
      "value": "Selektvracht"
    },
    {
      "id": 950,
      "address": "seur",
      "value": "International Seur"
    },
    {
      "id": 951,
      "address": "sfjhd",
      "value": "圣飞捷快递"
    },
    {
      "id": 952,
      "address": "sfpost",
      "value": "曹操到"
    },
    {
      "id": 953,
      "address": "sfwl",
      "value": "盛丰物流"
    },
    {
      "id": 954,
      "address": "shanda56",
      "value": "衫达快运"
    },
    {
      "id": 955,
      "address": "shanghaiwujiangmmb",
      "value": "上海无疆for买卖宝"
    },
    {
      "id": 956,
      "address": "shaoke",
      "value": "捎客物流"
    },
    {
      "id": 957,
      "address": "shengtongscm",
      "value": "盛通快递"
    },
    {
      "id": 958,
      "address": "shenma",
      "value": "神马快递"
    },
    {
      "id": 959,
      "address": "shiningexpress",
      "value": "阳光快递"
    },
    {
      "id": 960,
      "address": "shipbyace",
      "value": "王牌快递"
    },
    {
      "id": 961,
      "address": "shipsoho",
      "value": "苏豪快递"
    },
    {
      "id": 962,
      "address": "shiyunkuaidi",
      "value": "世运快递"
    },
    {
      "id": 963,
      "address": "shpostwish",
      "value": "wish邮"
    },
    {
      "id": 964,
      "address": "shunshid",
      "value": "顺士达速运"
    },
    {
      "id": 965,
      "address": "sihaiet",
      "value": "四海快递"
    },
    {
      "id": 966,
      "address": "sihiexpress",
      "value": "四海捷运"
    },
    {
      "id": 967,
      "address": "sinoairinex",
      "value": "中外运空运"
    },
    {
      "id": 968,
      "address": "sixroad",
      "value": "易普递"
    },
    {
      "id": 969,
      "address": "skynet",
      "value": "skynet"
    },
    {
      "id": 970,
      "address": "skypost",
      "value": "荷兰Sky Post"
    },
    {
      "id": 971,
      "address": "slovenia",
      "value": "斯洛文尼亚(Slovenia Post)"
    },
    {
      "id": 972,
      "address": "slpost",
      "value": "斯里兰卡(Sri Lanka Post)"
    },
    {
      "id": 973,
      "address": "speeda",
      "value": "行必达"
    },
    {
      "id": 974,
      "address": "speedoex",
      "value": "申必达"
    },
    {
      "id": 975,
      "address": "staky",
      "value": "首通快运"
    },
    {
      "id": 976,
      "address": "starex",
      "value": "星速递"
    },
    {
      "id": 977,
      "address": "subaoex",
      "value": "速豹"
    },
    {
      "id": 978,
      "address": "sucheng",
      "value": "速呈宅配"
    },
    {
      "id": 979,
      "address": "sudapost",
      "value": "苏丹（Sudapost）"
    },
    {
      "id": 980,
      "address": "sujievip",
      "value": "郑州速捷"
    },
    {
      "id": 981,
      "address": "sunspeedy",
      "value": "新速航"
    },
    {
      "id": 982,
      "address": "superoz",
      "value": "速配欧翼"
    },
    {
      "id": 983,
      "address": "supinexpress",
      "value": "速品快递"
    },
    {
      "id": 984,
      "address": "sureline",
      "value": "Sureline冠泰"
    },
    {
      "id": 985,
      "address": "surpassgo",
      "value": "天越物流"
    },
    {
      "id": 986,
      "address": "sycawl",
      "value": "狮爱高铁物流"
    },
    {
      "id": 987,
      "address": "taimek",
      "value": "天美快递"
    },
    {
      "id": 988,
      "address": "tanzania",
      "value": "坦桑尼亚(Tanzania Posts)"
    },
    {
      "id": 989,
      "address": "taoplus",
      "value": "淘布斯国际物流"
    },
    {
      "id": 990,
      "address": "tcixps",
      "value": "TCI XPS"
    },
    {
      "id": 991,
      "address": "tcxbthai",
      "value": "TCXB国际物流"
    },
    {
      "id": 992,
      "address": "tianma",
      "value": "天马迅达"
    },
    {
      "id": 993,
      "address": "tianxiang",
      "value": "天翔快递"
    },
    {
      "id": 994,
      "address": "tianzong",
      "value": "天纵物流"
    },
    {
      "id": 995,
      "address": "timedg",
      "value": "万家通快递"
    },
    {
      "id": 996,
      "address": "tlky",
      "value": "天联快运"
    },
    {
      "id": 997,
      "address": "tntitaly",
      "value": "TNT Italy"
    },
    {
      "id": 998,
      "address": "tntpostcn",
      "value": "TNT Post"
    },
    {
      "id": 999,
      "address": "tny",
      "value": "TNY物流"
    },
    {
      "id": 1000,
      "address": "toll",
      "value": "Toll"
    },
    {
      "id": 1001,
      "address": "tollpriority",
      "value": "Toll Priority(Toll Online)"
    },
    {
      "id": 1002,
      "address": "tongdaxing",
      "value": "通达兴物流"
    },
    {
      "id": 1003,
      "address": "tonghetianxia",
      "value": "通和天下"
    },
    {
      "id": 1004,
      "address": "topshey",
      "value": "顶世国际物流"
    },
    {
      "id": 1005,
      "address": "tswlcloud",
      "value": "天使物流云"
    },
    {
      "id": 1006,
      "address": "tunisia",
      "value": "突尼斯EMS(Rapid-Poste)"
    },
    {
      "id": 1007,
      "address": "turtle",
      "value": "海龟国际快递"
    },
    {
      "id": 1008,
      "address": "uex",
      "value": "UEX国际物流"
    },
    {
      "id": 1009,
      "address": "uganda",
      "value": "乌干达(Posta Uganda)"
    },
    {
      "id": 1010,
      "address": "ugoexpress",
      "value": "邮鸽速运"
    },
    {
      "id": 1011,
      "address": "ukraine",
      "value": "乌克兰小包、大包(UkrPoshta)"
    },
    {
      "id": 1012,
      "address": "ukrpost",
      "value": "乌克兰小包、大包(UkrPost)"
    },
    {
      "id": 1013,
      "address": "upsfreight",
      "value": "UPS Freight"
    },
    {
      "id": 1014,
      "address": "upsmailinno",
      "value": "UPS Mail Innovations"
    },
    {
      "id": 1015,
      "address": "utaoscm",
      "value": "UTAO优到"
    },
    {
      "id": 1016,
      "address": "vancl",
      "value": "凡客配送（作废）"
    },
    {
      "id": 1017,
      "address": "vietnam",
      "value": "越南小包(Vietnam Posts)"
    },
    {
      "id": 1018,
      "address": "vipexpress",
      "value": "鹰运国际速递"
    },
    {
      "id": 1019,
      "address": "vnpost",
      "value": "越南EMS(VNPost Express)"
    },
    {
      "id": 1020,
      "address": "vps",
      "value": "维普恩物流"
    },
    {
      "id": 1021,
      "address": "wanboex",
      "value": "万博快递"
    },
    {
      "id": 1022,
      "address": "wandougongzhu",
      "value": "豌豆物流"
    },
    {
      "id": 1023,
      "address": "wanjiatong",
      "value": "宁夏万家通"
    },
    {
      "id": 1024,
      "address": "wdm",
      "value": "万达美"
    },
    {
      "id": 1025,
      "address": "weilaimingtian",
      "value": "未来明天快递"
    },
    {
      "id": 1026,
      "address": "whgjkd",
      "value": "香港伟豪国际物流"
    },
    {
      "id": 1027,
      "address": "wlfast",
      "value": "凡仕特物流"
    },
    {
      "id": 1028,
      "address": "wtdex",
      "value": "WTD海外通"
    },
    {
      "id": 1029,
      "address": "wuyuansudi",
      "value": "伍圆速递"
    },
    {
      "id": 1030,
      "address": "wygj168",
      "value": "万运国际快递"
    },
    {
      "id": 1031,
      "address": "wzhaunyun",
      "value": "微转运"
    },
    {
      "id": 1032,
      "address": "xaetc",
      "value": "西安胜峰"
    },
    {
      "id": 1033,
      "address": "xdshipping",
      "value": "国晶物流"
    },
    {
      "id": 1034,
      "address": "xianchengliansudi",
      "value": "西安城联速递"
    },
    {
      "id": 1035,
      "address": "xianfeng",
      "value": "先锋快递"
    },
    {
      "id": 1036,
      "address": "xiangdawuliu",
      "value": "湘达物流"
    },
    {
      "id": 1037,
      "address": "xiangteng",
      "value": "翔腾物流"
    },
    {
      "id": 1038,
      "address": "xiaocex",
      "value": "小C海淘"
    },
    {
      "id": 1039,
      "address": "xingyuankuaidi",
      "value": "新元快递"
    },
    {
      "id": 1040,
      "address": "xinning",
      "value": "新宁物流"
    },
    {
      "id": 1041,
      "address": "xintianjie",
      "value": "信天捷快递"
    },
    {
      "id": 1042,
      "address": "xiyoug",
      "value": "西游寄"
    },
    {
      "id": 1043,
      "address": "xsrd",
      "value": "鑫世锐达"
    },
    {
      "id": 1044,
      "address": "xyd666",
      "value": "鑫远东速运"
    },
    {
      "id": 1045,
      "address": "yamaxunwuliu",
      "value": "亚马逊中国"
    },
    {
      "id": 1046,
      "address": "yatexpress",
      "value": "乾坤物流"
    },
    {
      "id": 1047,
      "address": "yatfai",
      "value": "一辉物流"
    },
    {
      "id": 1048,
      "address": "ycgglobal",
      "value": "YCG物流"
    },
    {
      "id": 1049,
      "address": "ydglobe",
      "value": "云达通"
    },
    {
      "id": 1050,
      "address": "yemen",
      "value": "也门(Yemen Post)"
    },
    {
      "id": 1051,
      "address": "yfsuyun",
      "value": "驭丰速运"
    },
    {
      "id": 1052,
      "address": "yhtlogistics",
      "value": "宇航通物流"
    },
    {
      "id": 1053,
      "address": "yidihui",
      "value": "驿递汇速递"
    },
    {
      "id": 1054,
      "address": "yiex",
      "value": "宜送物流"
    },
    {
      "id": 1055,
      "address": "yihangmall",
      "value": "易航物流"
    },
    {
      "id": 1056,
      "address": "yilingsuyun",
      "value": "亿领速运"
    },
    {
      "id": 1057,
      "address": "yinsu",
      "value": "音素快运"
    },
    {
      "id": 1058,
      "address": "yiqiguojiwuliu",
      "value": "一柒国际物流"
    },
    {
      "id": 1059,
      "address": "yishunhang",
      "value": "亿顺航"
    },
    {
      "id": 1060,
      "address": "yisong",
      "value": "宜送"
    },
    {
      "id": 1061,
      "address": "yitongda",
      "value": "易通达"
    },
    {
      "id": 1062,
      "address": "yiyou",
      "value": "易邮速运"
    },
    {
      "id": 1063,
      "address": "ykouan",
      "value": "洋口岸"
    },
    {
      "id": 1064,
      "address": "yodel",
      "value": "YODEL"
    },
    {
      "id": 1065,
      "address": "yongbangwuliu",
      "value": "永邦国际物流"
    },
    {
      "id": 1066,
      "address": "yongwangda",
      "value": "永旺达快递"
    },
    {
      "id": 1067,
      "address": "youban",
      "value": "邮邦国际"
    },
    {
      "id": 1068,
      "address": "youlai",
      "value": "邮来速递"
    },
    {
      "id": 1069,
      "address": "ypsd",
      "value": "壹品速递"
    },
    {
      "id": 1070,
      "address": "yuanzhijiecheng",
      "value": "元智捷诚"
    },
    {
      "id": 1071,
      "address": "yuezhongsh",
      "value": "粤中国际货运代理（上海）有限公司"
    },
    {
      "id": 1072,
      "address": "yufeng",
      "value": "御风速运"
    },
    {
      "id": 1073,
      "address": "yujiawuliu",
      "value": "煜嘉物流"
    },
    {
      "id": 1074,
      "address": "yundx",
      "value": "运东西"
    },
    {
      "id": 1075,
      "address": "yunexpress",
      "value": "德国云快递"
    },
    {
      "id": 1076,
      "address": "yunfeng56",
      "value": "韵丰物流"
    },
    {
      "id": 1077,
      "address": "yw56",
      "value": "燕文物流"
    },
    {
      "id": 1078,
      "address": "ywexpress",
      "value": "远为快递"
    },
    {
      "id": 1079,
      "address": "yyexp",
      "value": "西安运逸快递"
    },
    {
      "id": 1080,
      "address": "yyqc56",
      "value": "一运全成物流"
    },
    {
      "id": 1081,
      "address": "yzswuliu",
      "value": "亚洲顺物流"
    },
    {
      "id": 1082,
      "address": "zdepost",
      "value": "直德邮"
    },
    {
      "id": 1083,
      "address": "zenzen",
      "value": "三三国际物流"
    },
    {
      "id": 1084,
      "address": "zf365",
      "value": "珠峰速运"
    },
    {
      "id": 1085,
      "address": "zgyzt",
      "value": "一站通快递"
    },
    {
      "id": 1086,
      "address": "zhdwl",
      "value": "众辉达物流"
    },
    {
      "id": 1087,
      "address": "zhitengwuliu",
      "value": "志腾物流"
    },
    {
      "id": 1088,
      "address": "zhongruisudi",
      "value": "中睿速递"
    },
    {
      "id": 1089,
      "address": "zhongxinda",
      "value": "忠信达"
    },
    {
      "id": 1090,
      "address": "zhpex",
      "value": "众派速递"
    },
    {
      "id": 1091,
      "address": "zhuoshikuaiyun",
      "value": "卓实快运"
    },
    {
      "id": 1092,
      "address": "zjgj56",
      "value": "振捷国际货运"
    },
    {
      "id": 1093,
      "address": "zqlwl",
      "value": "青旅物流"
    },
    {
      "id": 1094,
      "address": "zsda56",
      "value": "转瞬达集运"
    },
    {
      "id": 1095,
      "address": "zsky123",
      "value": "准实快运"
    },
    {
      "id": 1096,
      "address": "ztjieda",
      "value": "泰捷达国际物流"
    },
    {
      "id": 1097,
      "address": "ydhex",
      "value": "义达快递"
    },
    {
      "id": 1098,
      "address": "jtexpress",
      "value": "极兔速递"
    },
  ]
}